const words = [
  {
    "name": "best salad delivery",
    "slug": "https://www.inspiredgo.ca/pages/static/best-salad-delivery"
  },
  {
    "name": "best salad delivery plans",
    "slug": "https://www.inspiredgo.ca/pages/static/best-salad-delivery-plans"
  },
  {
    "name": "healthy salad delivery service",
    "slug": "https://wwww.inspiredgo.ca/pages/static/healthy-salad-delivery-service"
  },
  {
    "name": "salad meal prep services",
    "slug": "https://www.inspiredgo.ca/pages/static/salad-meal-prep-services"
  },
  {
    "name": "fresh salad delivery options",
    "slug": "https://www.inspiredgo.ca/pages/static/fresh-salad-delivery-options"
  },
  {
    "name": "salad delivery service",
    "slug": "https://www.inspiredgo.ca/pages/static/salad-delivery-service"
  },
  {
    "name": "customized salad meal plans",
    "slug": "https://www.inspiredgo.ca/pages/static/customized-salad-meal-plans"
  },
  {
    "name": "salad meal delivery options",
    "slug": "https://www.inspiredgo.ca/pages/static/salad-meal-delivery-options"
  },
  {
    "name": "pre-made salad delivery",
    "slug": "https://www.inspiredgo.ca/pages/static/pre-made-salad-delivery"
  },
  {
    "name": "customized salad meal prep",
    "slug": "https://www.inspiredgo.ca/pages/static/customized-salad-meal-prep"
  },
  {
    "name": "top-rated salad delivery",
    "slug": "https://www.inspiredgo.ca/pages/static/top-rated-salad-delivery"
  },
  {
    "name": "salad delivery service online",
    "slug": "https://www.inspiredgo.ca/pages/static/salad-delivery-service-online"
  },
  {
    "name": "healthy salad prep service",
    "slug": "https://www.inspiredgo.ca/pages/static/healthy-salad-prep-service"
  },
  {
    "name": "weekly salad prep delivery service",
    "slug": "https://www.inspiredgo.ca/pages/static/weekly-salad-prep-delivery-service"
  },
  {
    "name": "organic salad delivery service",
    "slug": "https://www.inspiredgo.ca/pages/static/organic-salad-delivery-service"
  },
  {
    "name": "salad prep and delivery",
    "slug": "https://www.inspiredgo.ca/pages/static/salad-prep-and-delivery"
  },
  {
    "name": "best fresh salad delivery",
    "slug": "https://www.inspiredgo.ca/pages/static/best-fresh-salad-delivery"
  },
  {
    "name": "fresh salad meal prep plans",
    "slug": "https://www.inspiredgo.ca/pages/static/fresh-salad-meal-prep-plans"
  },
  {
    "name": "salad prep service",
    "slug": "https://www.inspiredgo.ca/pages/static/salad-prep-service"
  },
  {
    "name": "healthy salad meal delivery",
    "slug": "https://www.inspiredgo.ca/pages/static/healthy-salad-meal-delivery"
  },
  {
    "name": "salad prep for weight loss",
    "slug": "https://www.inspiredgo.ca/pages/static/salad-prep-for-weight-loss"
  },
  {
    "name": "ready-to-eat salad delivery",
    "slug": "https://www.inspiredgo.ca/pages/static/ready-to-eat-salad-delivery"
  },
  {
    "name": "salad delivery for offices",
    "slug": "https://www.inspiredgo.ca/pages/static/salad-delivery-for-offices"
  },
  {
    "name": "weekly salad meal prep",
    "slug": "https://www.inspiredgo.ca/pages/static/weekly-salad-meal-prep"
  },
  {
    "name": "fresh salad prep options",
    "slug": "https://www.inspiredgo.ca/pages/static/fresh-salad-prep-options"
  },
  {
    "name": "customizable salad delivery service",
    "slug": "https://www.inspiredgo.ca/pages/static/customizable-salad-delivery-service"
  },
  {
    "name": "organic salad meal delivery",
    "slug": "https://www.inspiredgo.ca/pages/static/organic-salad-meal-delivery"
  },
  {
    "name": "salad delivery for lunch",
    "slug": "https://www.inspiredgo.ca/pages/static/salad-delivery-for-lunch"
  },
  {
    "name": "professional salad prep service",
    "slug": "https://www.inspiredgo.ca/pages/static/professional-salad-prep-service"
  },
  {
    "name": "fresh greens delivery service",
    "slug": "https://www.inspiredgo.ca/pages/static/fresh-greens-delivery-service"
  },
  {
    "name": "salad meal prep kits",
    "slug": "https://www.inspiredgo.ca/pages/static/salad-meal-prep-kits"
  },
  {
    "name": "salad delivery subscription service",
    "slug": "https://www.inspiredgo.ca/pages/static/salad-delivery-subscription-service"
  },
  {
    "name": "meal-prepped salad delivery",
    "slug": "https://www.inspiredgo.ca/pages/static/meal-prepped-salad-delivery"
  },
  {
    "name": "healthy salad delivery options",
    "slug": "https://www.inspiredgo.ca/pages/static/healthy-salad-delivery-options"
  },
  {
    "name": "organic salad prep services",
    "slug": "https://www.inspiredgo.ca/pages/static/organic-salad-prep-services"
  },
  {
    "name": "ready-made salad delivery",
    "slug": "https://www.inspiredgo.ca/pages/static/ready-made-salad-delivery"
  },
  {
    "name": "salad meal prep",
    "slug": "https://www.inspiredgo.ca/pages/static/salad-meal-prep"
  },
  {
    "name": "fresh salad for delivery",
    "slug": "https://www.inspiredgo.ca/pages/static/fresh-salad-for-delivery"
  },
  {
    "name": "salad delivery for families",
    "slug": "https://www.inspiredgo.ca/pages/static/salad-delivery-for-families"
  },
  {
    "name": "best salad prep services",
    "slug": "https://www.inspiredgo.ca/pages/static/best-salad-prep-services"
  },
  {
    "name": "salad prep and packaging",
    "slug": "https://www.inspiredgo.ca/pages/static/salad-prep-and-packaging"
  },
  {
    "name": "salad delivery for individuals",
    "slug": "https://www.inspiredgo.ca/pages/static/salad-delivery-for-individuals"
  },
  {
    "name": "healthy meal salad prep",
    "slug": "https://www.inspiredgo.ca/pages/static/healthy-meal-salad-prep"
  },
  {
    "name": "fresh salad meal delivery",
    "slug": "https://www.inspiredgo.ca/pages/static/fresh-salad-meal-delivery"
  },
  {
    "name": "pre-packaged salad delivery",
    "slug": "https://www.inspiredgo.ca/pages/static/pre-packaged-salad-delivery"
  },
  {
    "name": "organic salad delivery near me",
    "slug": "https://www.inspiredgo.ca/pages/static/organic-salad-delivery-near-me"
  },
  {
    "name": "salad delivery for events",
    "slug": "https://www.inspiredgo.ca/pages/static/salad-delivery-for-events"
  },
  {
    "name": "salad delivery options",
    "slug": "https://www.inspiredgo.ca/pages/static/salad-delivery-options"
  },
  {
    "name": "fresh salad meal kits",
    "slug": "https://www.inspiredgo.ca/pages/static/fresh-salad-meal-kits"
  },
  {
    "name": "top salad delivery service",
    "slug": "https://www.inspiredgo.ca/pages/static/top-salad-delivery-service"
  },
  {
    "name": "best organic salad delivery",
    "slug": "https://www.inspiredgo.ca/pages/static/best-organic-salad-delivery"
  },
  {
    "name": "healthy salad delivery subscription",
    "slug": "https://www.inspiredgo.ca/pages/static/healthy-salad-delivery-subscription"
  },
  {
    "name": "salad prep service near me",
    "slug": "https://www.inspiredgo.ca/pages/static/salad-prep-service-near-me"
  },
  {
    "name": "salad meal delivery plans",
    "slug": "https://www.inspiredgo.ca/pages/static/salad-meal-delivery-plans"
  },
  {
    "name": "customizable salad prep options",
    "slug": "https://www.inspiredgo.ca/pages/static/customizable-salad-prep-options"
  },
  {
    "name": "fresh salad delivery subscription",
    "slug": "https://www.inspiredgo.ca/pages/static/fresh-salad-delivery-subscription"
  },
  {
    "name": "gourmet salad delivery service",
    "slug": "https://www.inspiredgo.ca/pages/static/gourmet-salad-delivery-service"
  },
  {
    "name": "salad prep and meal plans",
    "slug": "https://www.inspiredgo.ca/pages/static/salad-prep-and-meal-plans"
  },
  {
    "name": "salad delivery for busy professionals",
    "slug": "https://www.inspiredgo.ca/pages/static/salad-delivery-for-busy-professionals"
  },
  {
    "name": "best salad delivery subscription",
    "slug": "https://www.inspiredgo.ca/pages/static/best-salad-delivery-subscription"
  },
  {
    "name": "organic salad meal kits",
    "slug": "https://www.inspiredgo.ca/pages/static/organic-salad-meal-kits"
  },
  {
    "name": "salad delivery for small groups",
    "slug": "https://www.inspiredgo.ca/pages/static/salad-delivery-for-small-groups"
  },
  {
    "name": "best salad delivery near me",
    "slug": "https://www.inspiredgo.ca/pages/static/best-salad-delivery-near-me"
  },
  {
    "name": "weekly salad delivery service",
    "slug": "https://www.inspiredgo.ca/pages/static/weekly-salad-delivery-service"
  },
  {
    "name": "salad prep for healthy eating",
    "slug": "https://www.inspiredgo.ca/pages/static/salad-prep-for-healthy-eating"
  },
  {
    "name": "ready-to-go salad delivery",
    "slug": "https://www.inspiredgo.ca/pages/static/ready-to-go-salad-delivery"
  },
  {
    "name": "fresh salad family meal kits",
    "slug": "https://www.inspiredgo.ca/pages/static/fresh-salad-family-meal-kits"
  },
  {
    "name": "salad delivery service for parties",
    "slug": "https://www.inspiredgo.ca/pages/static/salad-delivery-service-for-parties"
  },
  {
    "name": "healthy salad meal kits",
    "slug": "https://www.inspiredgo.ca/pages/static/healthy-salad-meal-kits"
  },
  {
    "name": "prepped salad delivery service",
    "slug": "https://www.inspiredgo.ca/pages/static/prepped-salad-delivery-service"
  },
  {
    "name": "fresh salad delivery near me",
    "slug": "https://www.inspiredgo.ca/pages/static/fresh-salad-delivery-near-me"
  },
  {
    "name": "salad delivery for health-conscious individuals",
    "slug": "https://www.inspiredgo.ca/pages/static/salad-delivery-for-health-conscious-individuals"
  },
  {
    "name": "premium salad meal delivery",
    "slug": "https://www.inspiredgo.ca/pages/static/premium-salad-meal-delivery"
  },
  {
    "name": "salad prep for busy schedules",
    "slug": "https://www.inspiredgo.ca/pages/static/salad-prep-for-busy-schedules"
  },
  {
    "name": "best ready-made salad delivery",
    "slug": "https://www.inspiredgo.ca/pages/static/best-ready-made-salad-delivery"
  },
  {
    "name": "salad delivery service for families",
    "slug": "https://www.inspiredgo.ca/pages/static/salad-delivery-service-for-families"
  },
  {
    "name": "fresh salad subscription options",
    "slug": "https://www.inspiredgo.ca/pages/static/fresh-salad-subscription-options"
  },
  {
    "name": "organic meal prep salads",
    "slug": "https://www.inspiredgo.ca/pages/static/organic-meal-prep-salads"
  },
  {
    "name": "salad delivery service for schools",
    "slug": "https://www.inspiredgo.ca/pages/static/salad-delivery-service-for-schools"
  },
  {
    "name": "salad subscription service",
    "slug": "https://www.inspiredgo.ca/pages/static/salad-subscription-service"
  },
  {
    "name": "salad prep and packaging service",
    "slug": "https://www.inspiredgo.ca/pages/static/salad-prep-and-packaging-service"
  },
  {
    "name": "salad delivery for fitness goals",
    "slug": "https://www.inspiredgo.ca/pages/static/salad-delivery-for-fitness-goals"
  },
  {
    "name": "top-rated salad meal prep",
    "slug": "https://www.inspiredgo.ca/pages/static/top-rated-salad-meal-prep"
  },
  {
    "name": "fresh salad prep and delivery",
    "slug": "https://www.inspiredgo.ca/pages/static/fresh-salad-prep-and-delivery"
  },
  {
    "name": "weekly salad meal delivery",
    "slug": "https://www.inspiredgo.ca/pages/static/weekly-salad-meal-delivery"
  },
  {
    "name": "custom salad meal plans delivered",
    "slug": "https://www.inspiredgo.ca/pages/static/custom-salad-meal-plans-delivered"
  },
  {
    "name": "customizable salad subscription service",
    "slug": "https://www.inspiredgo.ca/pages/static/customizable-salad-subscription-service"
  },
  {
    "name": "gourmet salad prep service",
    "slug": "https://www.inspiredgo.ca/pages/static/gourmet-salad-prep-service"
  },
  {
    "name": "healthy salad delivery kits",
    "slug": "https://www.inspiredgo.ca/pages/static/healthy-salad-delivery-kits"
  },
  {
    "name": "salad prep services for offices",
    "slug": "https://www.inspiredgo.ca/pages/static/salad-prep-services-for-offices"
  },
  {
    "name": "ready-to-serve salad delivery",
    "slug": "https://www.inspiredgo.ca/pages/static/ready-to-serve-salad-delivery"
  },
  {
    "name": "best fresh salad options",
    "slug": "https://www.inspiredgo.ca/pages/static/best-fresh-salad-options"
  },
  {
    "name": "best salad meal options",
    "slug": "https://www.inspiredgo.ca/pages/static/best-salad-meal-options"
  },
  {
    "name": "salad delivery service for large groups",
    "slug": "https://www.inspiredgo.ca/pages/static/salad-delivery-service-for-large-groups"
  },
  {
    "name": "healthy salad prep and delivery",
    "slug": "https://www.inspiredgo.ca/pages/static/healthy-salad-prep-and-delivery"
  },
  {
    "name": "pre-made salad meal kits",
    "slug": "https://www.inspiredgo.ca/pages/static/pre-made-salad-meal-kits"
  },
  {
    "name": "salad meal subscription service",
    "slug": "https://www.inspiredgo.ca/pages/static/salad-meal-subscription-service"
  },
  {
    "name": "fresh salad meal plans",
    "slug": "https://www.inspiredgo.ca/pages/static/fresh-salad-meal-plans"
  },
  {
    "name": "salad delivery for fitness enthusiasts",
    "slug": "https://www.inspiredgo.ca/pages/static/salad-delivery-for-fitness-enthusiasts"
  },
  {
    "name": "organic salad delivery options",
    "slug": "https://www.inspiredgo.ca/pages/static/organic-salad-delivery-options"
  },
  {
    "name": "vegan meal delivery service",
    "slug": "https://www.inspiredgo.ca/pages/static/vegan-meal-delivery-service"
  },
  {
    "name": "best vegan delivery",
    "slug": "https://www.inspiredgo.ca/pages/static/best-vegan-delivery"
  },
  {
    "name": "vegan meals delivered near me",
    "slug": "https://www.inspiredgo.ca/pages/static/vegan-meals-delivered-near-me"
  },
  {
    "name": "vegan meal delivery",
    "slug": "https://www.inspiredgo.ca/pages/static/vegan-meal-delivery"
  },
  {
    "name": "weekly vegan meal prep",
    "slug": "https://www.inspiredgo.ca/pages/static/weekly-vegan-meal-prep"
  },
  {
    "name": "fresh vegan food delivery",
    "slug": "https://www.inspiredgo.ca/pages/static/fresh-vegan-food-delivery"
  },
  {
    "name": "vegan meal kits delivered",
    "slug": "https://www.inspiredgo.ca/pages/static/vegan-meal-kits-delivered"
  },
  {
    "name": "vegan meal delivery plans",
    "slug": "https://www.inspiredgo.ca/pages/static/vegan-meal-delivery-plans"
  },
  {
    "name": "top-rated vegan meal prep",
    "slug": "https://www.inspiredgo.ca/pages/static/top-rated-vegan-meal-prep"
  },
  {
    "name": "vegan meal prep near me",
    "slug": "https://www.inspiredgo.ca/pages/static/vegan-meal-prep-near-me"
  },
  {
    "name": "plant-based meal delivery service",
    "slug": "https://www.inspiredgo.ca/pages/static/plant-based-meal-delivery-service"
  },
  {
    "name": "convenient vegan meal delivery",
    "slug": "https://www.inspiredgo.ca/pages/static/convenient-vegan-meal-delivery"
  },
  {
    "name": "vegan food prep services",
    "slug": "https://www.inspiredgo.ca/pages/static/vegan-food-prep-services"
  },
  {
    "name": "ready-to-eat vegan meals",
    "slug": "https://www.inspiredgo.ca/pages/static/ready-to-eat-vegan-meals"
  },
  {
    "name": "personalized vegan meal prep",
    "slug": "https://www.inspiredgo.ca/pages/static/personalized-vegan-meal-prep"
  },
  {
    "name": "vegan meal delivery for families",
    "slug": "https://www.inspiredgo.ca/pages/static/vegan-meal-delivery-for-families"
  },
  {
    "name": "vegan meal delivery subscription",
    "slug": "https://www.inspiredgo.ca/pages/static/vegan-meal-delivery-subscription"
  },
  {
    "name": "vegan food delivery options",
    "slug": "https://www.inspiredgo.ca/pages/static/vegan-food-delivery-options"
  },
  {
    "name": "vegan weekly meal subscription",
    "slug": "https://www.inspiredgo.ca/pages/static/vegan-weekly-meal-subscription"
  },
  {
    "name": "best vegan meal kits",
    "slug": "https://www.inspiredgo.ca/pages/static/best-vegan-meal-kits"
  },
  {
    "name": "healthy vegan meal delivery",
    "slug": "https://www.inspiredgo.ca/pages/static/healthy-vegan-meal-delivery"
  },
  {
    "name": "vegan meal prep service online",
    "slug": "https://www.inspiredgo.ca/pages/static/vegan-meal-prep-service-online"
  },
  {
    "name": "vegan dinner delivery near me",
    "slug": "https://www.inspiredgo.ca/pages/static/vegan-dinner-delivery-near-me"
  },
  {
    "name": "vegan lunch delivery options",
    "slug": "https://www.inspiredgo.ca/pages/static/vegan-lunch-delivery-options"
  },
  {
    "name": "vegan prep delivery",
    "slug": "https://www.inspiredgo.ca/pages/static/vegan-prep-delivery"
  },
  {
    "name": "pre-made vegan meals delivered",
    "slug": "https://www.inspiredgo.ca/pages/static/pre-made-vegan-meals-delivered"
  },
  {
    "name": "vegan meals for busy schedules",
    "slug": "https://www.inspiredgo.ca/pages/static/vegan-meals-for-busy-schedules"
  },
  {
    "name": "vegan meal prep delivery service",
    "slug": "https://www.inspiredgo.ca/pages/static/vegan-meal-prep-delivery-service"
  },
  {
    "name": "convenient plant-based meal delivery",
    "slug": "https://www.inspiredgo.ca/pages/static/convenient-plant-based-meal-delivery"
  },
  {
    "name": "fresh vegan meal delivery options",
    "slug": "https://www.inspiredgo.ca/pages/static/fresh-vegan-meal-delivery-options"
  },
  {
    "name": "best vegan dinner delivery",
    "slug": "https://www.inspiredgo.ca/pages/static/best-vegan-dinner-delivery"
  },
  {
    "name": "vegan food delivery service near me",
    "slug": "https://www.inspiredgo.ca/pages/static/vegan-food-delivery-service-near-me"
  },
  {
    "name": "plant-based food prep delivery",
    "slug": "https://www.inspiredgo.ca/pages/static/plant-based-food-prep-delivery"
  },
  {
    "name": "vegan weekly meal prep service",
    "slug": "https://www.inspiredgo.ca/pages/static/vegan-weekly-meal-prep-service"
  },
  {
    "name": "vegan meal plans",
    "slug": "https://www.inspiredgo.ca/pages/static/vegan-meal-plans"
  },
  {
    "name": "vegan ready-made meal delivery",
    "slug": "https://www.inspiredgo.ca/pages/static/vegan-ready-made-meal-delivery"
  },
  {
    "name": "quick vegan meal delivery",
    "slug": "https://www.inspiredgo.ca/pages/static/quick-vegan-meal-delivery"
  },
  {
    "name": "healthy vegan meal prep delivery",
    "slug": "https://www.inspiredgo.ca/pages/static/healthy-vegan-meal-prep-delivery"
  },
  {
    "name": "vegan family meal delivery",
    "slug": "https://www.inspiredgo.ca/pages/static/vegan-family-meal-delivery"
  },
  {
    "name": "meal prep vegan delivery service",
    "slug": "https://www.inspiredgo.ca/pages/static/meal-prep-vegan-delivery-service"
  },
  {
    "name": "plant-based meal prep",
    "slug": "https://www.inspiredgo.ca/pages/static/plant-based-meal-prep"
  },
  {
    "name": "vegan meal delivery for weight loss",
    "slug": "https://www.inspiredgo.ca/pages/static/vegan-meal-delivery-for-weight-loss"
  },
  {
    "name": "best vegan meal prep delivery",
    "slug": "https://www.inspiredgo.ca/pages/static/best-vegan-meal-prep-delivery"
  },
  {
    "name": "plant-based meal kits delivered",
    "slug": "https://www.inspiredgo.ca/pages/static/plant-based-meal-kits-delivered"
  },
  {
    "name": "fresh vegan dinner delivery",
    "slug": "https://www.inspiredgo.ca/pages/static/fresh-vegan-dinner-delivery"
  },
  {
    "name": "plant-based ready meal service",
    "slug": "https://www.inspiredgo.ca/pages/static/plant-based-ready-meal-service"
  },
  {
    "name": "vegan food prep for families",
    "slug": "https://www.inspiredgo.ca/pages/static/vegan-food-prep-for-families"
  },
  {
    "name": "weekly vegan food delivery",
    "slug": "https://www.inspiredgo.ca/pages/static/weekly-vegan-food-delivery"
  },
  {
    "name": "diet-friendly vegan meal delivery",
    "slug": "https://www.inspiredgo.ca/pages/static/diet-friendly-vegan-meal-delivery"
  },
  {
    "name": "plant-based meal delivery plans",
    "slug": "https://www.inspiredgo.ca/pages/static/plant-based-meal-delivery-plans"
  },
  {
    "name": "vegan food prep delivery kits",
    "slug": "https://www.inspiredgo.ca/pages/static/vegan-food-prep-delivery-kits"
  },
  {
    "name": "fresh vegan meal kits",
    "slug": "https://www.inspiredgo.ca/pages/static/fresh-vegan-meal-kits"
  },
  {
    "name": "ready-to-go vegan meals",
    "slug": "https://www.inspiredgo.ca/pages/static/ready-to-go-vegan-meals"
  },
  {
    "name": "convenient vegan meal plans",
    "slug": "https://www.inspiredgo.ca/pages/static/convenient-vegan-meal-plans"
  },
  {
    "name": "best vegan lunch delivery",
    "slug": "https://www.inspiredgo.ca/pages/static/best-vegan-lunch-delivery"
  },
  {
    "name": "plant-based dinner meal delivery",
    "slug": "https://www.inspiredgo.ca/pages/static/plant-based-dinner-meal-delivery"
  },
  {
    "name": "fresh vegan food near me",
    "slug": "https://www.inspiredgo.ca/pages/static/fresh-vegan-food-near-me"
  },
  {
    "name": "quick vegan prep delivery",
    "slug": "https://www.inspiredgo.ca/pages/static/quick-vegan-prep-delivery"
  },
  {
    "name": "prepped vegan meals for delivery",
    "slug": "https://www.inspiredgo.ca/pages/static/prepped-vegan-meals-for-delivery"
  },
  {
    "name": "plant-based food delivery subscription",
    "slug": "https://www.inspiredgo.ca/pages/static/plant-based-food-delivery-subscription"
  },
  {
    "name": "healthy vegan meal delivery near me",
    "slug": "https://www.inspiredgo.ca/pages/static/healthy-vegan-meal-delivery-near-me"
  },
  {
    "name": "best plant-based meal prep delivery",
    "slug": "https://www.inspiredgo.ca/pages/static/best-plant-based-meal-prep-delivery"
  },
  {
    "name": "vegan food delivery for offices",
    "slug": "https://www.inspiredgo.ca/pages/static/vegan-food-delivery-for-offices"
  },
  {
    "name": "weekly plant-based meal kits",
    "slug": "https://www.inspiredgo.ca/pages/static/weekly-plant-based-meal-kits"
  },
  {
    "name": "plant-based meal prep service",
    "slug": "https://www.inspiredgo.ca/pages/static/plant-based-meal-prep-service"
  },
  {
    "name": "quick-prep vegan meal delivery",
    "slug": "https://www.inspiredgo.ca/pages/static/quick-prep-vegan-meal-delivery"
  },
  {
    "name": "easy vegan food prep options",
    "slug": "https://www.inspiredgo.ca/pages/static/easy-vegan-food-prep-options"
  },
  {
    "name": "vegan meal delivery for professionals",
    "slug": "https://www.inspiredgo.ca/pages/static/vegan-meal-delivery-for-professionals"
  },
  {
    "name": "vegan food prep for health-conscious",
    "slug": "https://www.inspiredgo.ca/pages/static/vegan-food-prep-for-health-conscious"
  },
  {
    "name": "pre-made vegan dinner delivery",
    "slug": "https://www.inspiredgo.ca/pages/static/pre-made-vegan-dinner-delivery"
  },
  {
    "name": "plant-based meal delivery kits",
    "slug": "https://www.inspiredgo.ca/pages/static/plant-based-meal-delivery-kits"
  },
  {
    "name": "fresh vegan prep delivery service",
    "slug": "https://www.inspiredgo.ca/pages/static/fresh-vegan-prep-delivery-service"
  },
  {
    "name": "top vegan meal delivery options",
    "slug": "https://www.inspiredgo.ca/pages/static/top-vegan-meal-delivery-options"
  },
  {
    "name": "plant-based meal prep plans",
    "slug": "https://www.inspiredgo.ca/pages/static/plant-based-meal-prep-plans"
  },
  {
    "name": "vegan food prep services near me",
    "slug": "https://www.inspiredgo.ca/pages/static/vegan-food-prep-services-near-me"
  },
  {
    "name": "convenient vegan family meal delivery",
    "slug": "https://www.inspiredgo.ca/pages/static/convenient-vegan-family-meal-delivery"
  },
  {
    "name": "best vegan meal plans delivered",
    "slug": "https://www.inspiredgo.ca/pages/static/best-vegan-meal-plans-delivered"
  },
  {
    "name": "vegan meals for fitness goals",
    "slug": "https://www.inspiredgo.ca/pages/static/vegan-meals-for-fitness-goals"
  },
  {
    "name": "fresh vegan food prep for delivery",
    "slug": "https://www.inspiredgo.ca/pages/static/fresh-vegan-food-prep-for-delivery"
  },
  {
    "name": "pre-prepped vegan meal delivery",
    "slug": "https://www.inspiredgo.ca/pages/static/pre-prepped-vegan-meal-delivery"
  },
  {
    "name": "vegan food delivery service for offices",
    "slug": "https://www.inspiredgo.ca/pages/static/vegan-food-delivery-service-for-offices"
  },
  {
    "name": "best plant-based meal delivery service",
    "slug": "https://www.inspiredgo.ca/pages/static/best-plant-based-meal-delivery-service"
  },
  {
    "name": "vegan dinner prep delivery options",
    "slug": "https://www.inspiredgo.ca/pages/static/vegan-dinner-prep-delivery-options"
  },
  {
    "name": "vegan dinner delivery",
    "slug": "https://www.inspiredgo.ca/pages/static/vegan-dinner-delivery"
  },
  {
    "name": "weekly plant-based food delivery",
    "slug": "https://www.inspiredgo.ca/pages/static/weekly-plant-based-food-delivery"
  },
  {
    "name": "ready-to-eat vegan family meals",
    "slug": "https://www.inspiredgo.ca/pages/static/ready-to-eat-vegan-family-meals"
  },
  {
    "name": "plant-based food prep for diets",
    "slug": "https://www.inspiredgo.ca/pages/static/plant-based-food-prep-for-diets"
  },
  {
    "name": "fresh vegan meal prep services",
    "slug": "https://www.inspiredgo.ca/pages/static/fresh-vegan-meal-prep-services"
  },
  {
    "name": "vegan diet meal delivery plans",
    "slug": "https://www.inspiredgo.ca/pages/static/vegan-diet-meal-delivery-plans"
  },
  {
    "name": "vegan food delivery",
    "slug": "https://www.inspiredgo.ca/pages/static/vegan-food-delivery"
  },
  {
    "name": "pre-packaged vegan dinner kits",
    "slug": "https://www.inspiredgo.ca/pages/static/pre-packaged-vegan-dinner-kits"
  },
  {
    "name": "plant-based diet meal delivery",
    "slug": "https://www.inspiredgo.ca/pages/static/plant-based-diet-meal-delivery"
  },
  {
    "name": "best vegan food delivery service",
    "slug": "https://www.inspiredgo.ca/pages/static/best-vegan-food-delivery-service"
  },
  {
    "name": "vegan food prep for families",
    "slug": "https://www.inspiredgo.ca/pages/static/vegan-food-prep-for-families"
  },
  {
    "name": "quick vegan food delivery",
    "slug": "https://www.inspiredgo.ca/pages/static/quick-vegan-food-delivery"
  },
  {
    "name": "plant-based weekly meal prep",
    "slug": "https://www.inspiredgo.ca/pages/static/plant-based-weekly-meal-prep"
  },
  {
    "name": "vegan meals for health goals",
    "slug": "https://www.inspiredgo.ca/pages/static/vegan-meals-for-health-goals"
  },
  {
    "name": "fresh vegan meal delivery kits",
    "slug": "https://www.inspiredgo.ca/pages/static/fresh-vegan-meal-delivery-kits"
  },
  {
    "name": "best vegan meal delivery service",
    "slug": "https://www.inspiredgo.ca/pages/static/best-vegan-meal-delivery-service"
  },
  {
    "name": "plant-based food delivery",
    "slug": "https://www.inspiredgo.ca/pages/static/plant-based-food-delivery"
  },
  {
    "name": "best organic meal delivery",
    "slug": "https://www.inspiredgo.ca/pages/static/best-organic-meal-delivery"
  },
  {
    "name": "fresh organic meal service",
    "slug": "https://www.inspiredgo.ca/pages/static/fresh-organic-meal-service"
  },
  {
    "name": "meal prep organic kits",
    "slug": "https://www.inspiredgo.ca/pages/static/meal-prep-organic-kits"
  },
  {
    "name": "organic meal box service",
    "slug": "https://www.inspiredgo.ca/pages/static/organic-meal-box-service"
  },
  {
    "name": "top organic meal delivery",
    "slug": "https://www.inspiredgo.ca/pages/static/top-organic-meal-delivery"
  },
  {
    "name": "ready-made organic meals",
    "slug": "https://www.inspiredgo.ca/pages/static/ready-made-organic-meals"
  },
  {
    "name": "organic weekly meal kits",
    "slug": "https://www.inspiredgo.ca/pages/static/organic-weekly-meal-kits"
  },
  {
    "name": "best organic family meals",
    "slug": "https://www.inspiredgo.ca/pages/static/best-organic-family-meals"
  },
  {
    "name": "organic dinner meal kits",
    "slug": "https://www.inspiredgo.ca/pages/static/organic-dinner-meal-kits"
  },
  {
    "name": "organic meal prep service",
    "slug": "https://www.inspiredgo.ca/pages/static/organic-meal-prep-service"
  },
  {
    "name": "healthy organic meal plans",
    "slug": "https://www.inspiredgo.ca/pages/static/healthy-organic-meal-plans"
  },
  {
    "name": "custom organic meal delivery",
    "slug": "https://www.inspiredgo.ca/pages/static/custom-organic-meal-delivery"
  },
  {
    "name": "organic food subscription box",
    "slug": "https://www.inspiredgo.ca/pages/static/organic-food-subscription-box"
  },
  {
    "name": "weekly organic meal prep",
    "slug": "https://www.inspiredgo.ca/pages/static/weekly-organic-meal-prep"
  },
  {
    "name": "best organic meal plans",
    "slug": "https://www.inspiredgo.ca/pages/static/best-organic-meal-plans"
  },
  {
    "name": "organic diet meal kits",
    "slug": "https://www.inspiredgo.ca/pages/static/organic-diet-meal-kits"
  },
  {
    "name": "organic chef-prepared meals",
    "slug": "https://www.inspiredgo.ca/pages/static/organic-chef-prepared-meals"
  },
  {
    "name": "organic meal home delivery",
    "slug": "https://www.inspiredgo.ca/pages/static/organic-meal-home-delivery"
  },
  {
    "name": "organic meal box delivery",
    "slug": "https://www.inspiredgo.ca/pages/static/organic-meal-box-delivery"
  },
  {
    "name": "best organic weekly service",
    "slug": "https://www.inspiredgo.ca/pages/static/best-organic-weekly-service"
  },
  {
    "name": "organic fresh meal delivery",
    "slug": "https://www.inspiredgo.ca/pages/static/organic-fresh-meal-delivery"
  },
  {
    "name": "organic prepared meal kits",
    "slug": "https://www.inspiredgo.ca/pages/static/organic-prepared-meal-kits"
  },
  {
    "name": "healthy organic meal prep",
    "slug": "https://www.inspiredgo.ca/pages/static/healthy-organic-meal-prep"
  },
  {
    "name": "organic meal catering service",
    "slug": "https://www.inspiredgo.ca/pages/static/organic-meal-catering-service"
  },
  {
    "name": "organic food meal plans",
    "slug": "https://www.inspiredgo.ca/pages/static/organic-food-meal-plans"
  },
  {
    "name": "family organic meal kits",
    "slug": "https://www.inspiredgo.ca/pages/static/family-organic-meal-kits"
  },
  {
    "name": "organic food delivery service",
    "slug": "https://www.inspiredgo.ca/pages/static/organic-food-delivery-service"
  },
  {
    "name": "best organic food prep",
    "slug": "https://www.inspiredgo.ca/pages/static/best-organic-food-prep"
  },
  {
    "name": "organic meal plans delivered",
    "slug": "https://www.inspiredgo.ca/pages/static/organic-meal-plans-delivered"
  },
  {
    "name": "freshly prepared organic meals",
    "slug": "https://www.inspiredgo.ca/pages/static/freshly-prepared-organic-meals"
  },
  {
    "name": "organic dinner food prep",
    "slug": "https://www.inspiredgo.ca/pages/static/organic-dinner-food-prep"
  },
  {
    "name": "weekly organic meal service",
    "slug": "https://www.inspiredgo.ca/pages/static/weekly-organic-meal-service"
  },
  {
    "name": "organic food delivery plans",
    "slug": "https://www.inspiredgo.ca/pages/static/organic-food-delivery-plans"
  },
  {
    "name": "organic ready meal kits",
    "slug": "https://www.inspiredgo.ca/pages/static/organic-ready-meal-kits"
  },
  {
    "name": "organic lunch meal service",
    "slug": "https://www.inspiredgo.ca/pages/static/organic-lunch-meal-service"
  },
  {
    "name": "best weekly organic meals",
    "slug": "https://www.inspiredgo.ca/pages/static/best-weekly-organic-meals"
  },
  {
    "name": "organic family meal prep",
    "slug": "https://www.inspiredgo.ca/pages/static/organic-family-meal-prep"
  },
  {
    "name": "pre-prepared organic meals",
    "slug": "https://www.inspiredgo.ca/pages/static/pre-prepared-organic-meals"
  },
  {
    "name": "organic home food kits",
    "slug": "https://www.inspiredgo.ca/pages/static/organic-home-food-kits"
  },
  {
    "name": "organic chef-designed meals",
    "slug": "https://www.inspiredgo.ca/pages/static/organic-chef-designed-meals"
  },
  {
    "name": "weekly organic dinner kits",
    "slug": "https://www.inspiredgo.ca/pages/static/weekly-organic-dinner-kits"
  },
  {
    "name": "organic ready-made delivery",
    "slug": "https://www.inspiredgo.ca/pages/static/organic-ready-made-delivery"
  },
  {
    "name": "fresh organic dinner kits",
    "slug": "https://www.inspiredgo.ca/pages/static/fresh-organic-dinner-kits"
  },
  {
    "name": "organic family-friendly meals",
    "slug": "https://www.inspiredgo.ca/pages/static/organic-family-friendly-meals"
  },
  {
    "name": "healthy organic meal kits",
    "slug": "https://www.inspiredgo.ca/pages/static/healthy-organic-meal-kits"
  },
  {
    "name": "organic meal planning service",
    "slug": "https://www.inspiredgo.ca/pages/static/organic-meal-planning-service"
  },
  {
    "name": "organic pre-cooked meals",
    "slug": "https://www.inspiredgo.ca/pages/static/organic-pre-cooked-meals"
  },
  {
    "name": "organic nutrition meal plans",
    "slug": "https://www.inspiredgo.ca/pages/static/organic-nutrition-meal-plans"
  },
  {
    "name": "best organic dinner boxes",
    "slug": "https://www.inspiredgo.ca/pages/static/best-organic-dinner-boxes"
  },
  {
    "name": "weekly organic family meals",
    "slug": "https://www.inspiredgo.ca/pages/static/weekly-organic-family-meals"
  },
  {
    "name": "best organic weekly meal delivery",
    "slug": "https://www.inspiredgo.ca/pages/static/best-organic-weekly-meal-delivery"
  },
  {
    "name": "fresh organic meal subscription service",
    "slug": "https://www.inspiredgo.ca/pages/static/fresh-organic-meal-subscription-service"
  },
  {
    "name": "top-rated organic meal delivery service",
    "slug": "https://www.inspiredgo.ca/pages/static/top-rated-organic-meal-delivery-service"
  },
  {
    "name": "organic meal box subscription plans",
    "slug": "https://www.inspiredgo.ca/pages/static/organic-meal-box-subscription-plans"
  },
  {
    "name": "ready-to-eat organic meal kits",
    "slug": "https://www.inspiredgo.ca/pages/static/ready-to-eat-organic-meal-kits"
  },
  {
    "name": "organic weekly family meal plans",
    "slug": "https://www.inspiredgo.ca/pages/static/organic-weekly-family-meal-plans"
  },
  {
    "name": "customizable organic meal prep service",
    "slug": "https://www.inspiredgo.ca/pages/static/customizable-organic-meal-prep-service"
  },
  {
    "name": "organic dinner meal delivery kits",
    "slug": "https://www.inspiredgo.ca/pages/static/organic-dinner-meal-delivery-kits"
  },
  {
    "name": "healthy organic weekly meal service",
    "slug": "https://www.inspiredgo.ca/pages/static/healthy-organic-weekly-meal-service"
  },
  {
    "name": "freshly cooked organic meal delivery",
    "slug": "https://www.inspiredgo.ca/pages/static/freshly-cooked-organic-meal-delivery"
  },
  {
    "name": "organic meal prep catering service",
    "slug": "https://www.inspiredgo.ca/pages/static/organic-meal-prep-catering-service"
  },
  {
    "name": "organic balanced meal plan delivery",
    "slug": "https://www.inspiredgo.ca/pages/static/organic-balanced-meal-plan-delivery"
  },
  {
    "name": "organic pre-packaged meal service",
    "slug": "https://www.inspiredgo.ca/pages/static/organic-pre-packaged-meal-service"
  },
  {
    "name": "best organic home meal delivery",
    "slug": "https://www.inspiredgo.ca/pages/static/best-organic-home-meal-delivery"
  },
  {
    "name": "organic chef-prepared weekly meals",
    "slug": "https://www.inspiredgo.ca/pages/static/organic-chef-prepared-weekly-meals"
  },
  {
    "name": "healthy organic food prep service",
    "slug": "https://www.inspiredgo.ca/pages/static/healthy-organic-food-prep-service"
  },
  {
    "name": "fresh organic weekly dinner kits",
    "slug": "https://www.inspiredgo.ca/pages/static/fresh-organic-weekly-dinner-kits"
  },
  {
    "name": "organic family meal delivery service",
    "slug": "https://www.inspiredgo.ca/pages/static/organic-family-meal-delivery-service"
  },
  {
    "name": "organic ready-to-serve meal plans",
    "slug": "https://www.inspiredgo.ca/pages/static/organic-ready-to-serve-meal-plans"
  },
  {
    "name": "weekly organic prepared meal delivery",
    "slug": "https://www.inspiredgo.ca/pages/static/weekly-organic-prepared-meal-delivery"
  },
  {
    "name": "best organic pre-cooked meal service",
    "slug": "https://www.inspiredgo.ca/pages/static/best-organic-pre-cooked-meal-service"
  },
  {
    "name": "organic flexible meal delivery plans",
    "slug": "https://www.inspiredgo.ca/pages/static/organic-flexible-meal-delivery-plans"
  },
  {
    "name": "fresh organic lunch meal kits",
    "slug": "https://www.inspiredgo.ca/pages/static/fresh-organic-lunch-meal-kits"
  },
  {
    "name": "organic healthy meal subscription boxes",
    "slug": "https://www.inspiredgo.ca/pages/static/organic-healthy-meal-subscription-boxes"
  },
  {
    "name": "organic food prep delivery kits",
    "slug": "https://www.inspiredgo.ca/pages/static/organic-food-prep-delivery-kits"
  },
  {
    "name": "organic weekly family-friendly meals",
    "slug": "https://www.inspiredgo.ca/pages/static/organic-weekly-family-friendly-meals"
  },
  {
    "name": "tailored organic meal prep service",
    "slug": "https://www.inspiredgo.ca/pages/static/tailored-organic-meal-prep-service"
  },
  {
    "name": "organic seasonal meal box delivery",
    "slug": "https://www.inspiredgo.ca/pages/static/organic-seasonal-meal-box-delivery"
  },
  {
    "name": "best organic family meal subscriptions",
    "slug": "https://www.inspiredgo.ca/pages/static/best-organic-family-meal-subscriptions"
  },
  {
    "name": "organic convenient meal delivery plans",
    "slug": "https://www.inspiredgo.ca/pages/static/organic-convenient-meal-delivery-plans"
  },
  {
    "name": "organic home-cooked weekly meal kits",
    "slug": "https://www.inspiredgo.ca/pages/static/organic-home-cooked-weekly-meal-kits"
  },
  {
    "name": "custom weekly organic meal plans",
    "slug": "https://www.inspiredgo.ca/pages/static/custom-weekly-organic-meal-plans"
  },
  {
    "name": "organic chef-designed weekly meals",
    "slug": "https://www.inspiredgo.ca/pages/static/organic-chef-designed-weekly-meals"
  },
  {
    "name": "fresh organic nutrition meal delivery",
    "slug": "https://www.inspiredgo.ca/pages/static/fresh-organic-nutrition-meal-delivery"
  },
  {
    "name": "ready-made weekly organic meal kits",
    "slug": "https://www.inspiredgo.ca/pages/static/ready-made-weekly-organic-meal-kits"
  },
  {
    "name": "organic natural meal prep plans",
    "slug": "https://www.inspiredgo.ca/pages/static/organic-natural-meal-prep-plans"
  },
  {
    "name": "organic health-focused meal delivery",
    "slug": "https://www.inspiredgo.ca/pages/static/organic-health-focused-meal-delivery"
  },
  {
    "name": "organic wholesome weekly meal service",
    "slug": "https://www.inspiredgo.ca/pages/static/organic-wholesome-weekly-meal-service"
  },
  {
    "name": "best fresh organic food boxes",
    "slug": "https://www.inspiredgo.ca/pages/static/best-fresh-organic-food-boxes"
  },
  {
    "name": "organic flexible meal plan delivery",
    "slug": "https://www.inspiredgo.ca/pages/static/organic-flexible-meal-plan-delivery"
  },
  {
    "name": "organic weekly dinner box service",
    "slug": "https://www.inspiredgo.ca/pages/static/organic-weekly-dinner-box-service"
  },
  {
    "name": "organic meal catering service plans",
    "slug": "https://www.inspiredgo.ca/pages/static/organic-meal-catering-service-plans"
  },
  {
    "name": "customized organic weekly meal boxes",
    "slug": "https://www.inspiredgo.ca/pages/static/customized-organic-weekly-meal-boxes"
  },
  {
    "name": "ready-prepped organic meal service",
    "slug": "https://www.inspiredgo.ca/pages/static/ready-prepped-organic-meal-service"
  },
  {
    "name": "organic seasonal family meal delivery",
    "slug": "https://www.inspiredgo.ca/pages/static/organic-seasonal-family-meal-delivery"
  },
  {
    "name": "best organic weekly subscription kits",
    "slug": "https://www.inspiredgo.ca/pages/static/best-organic-weekly-subscription-kits"
  },
  {
    "name": "fresh organic balanced meal delivery",
    "slug": "https://www.inspiredgo.ca/pages/static/fresh-organic-balanced-meal-delivery"
  },
  {
    "name": "organic meal plan for families",
    "slug": "https://www.inspiredgo.ca/pages/static/organic-meal-plan-for-families"
  },
  {
    "name": "organic nutrition-focused meal plans",
    "slug": "https://www.inspiredgo.ca/pages/static/organic-nutrition-focused-meal-plans"
  },
  {
    "name": "organic easy-prep meal delivery",
    "slug": "https://www.inspiredgo.ca/pages/static/organic-easy-prep-meal-delivery"
  },
  {
    "name": "best healthy meal delivery",
    "slug": "https://www.inspiredgo.ca/pages/static/best-healthy-meal-delivery"
  },
  {
    "name": "best healthy food plans",
    "slug": "https://www.inspiredgo.ca/pages/static/best-healthy-food-plans"
  },
  {
    "name": "healthy meals delivered near me",
    "slug": "https://www.inspiredgo.ca/pages/static/healthy-meals-delivered-near-me"
  },
  {
    "name": "top rated healthy meal delivery",
    "slug": "https://www.inspiredgo.ca/pages/static/top-rated-healthy-meal-delivery"
  },
  {
    "name": "weekly healthy meal prep",
    "slug": "https://www.inspiredgo.ca/pages/static/weekly-healthy-meal-prep"
  },
  {
    "name": "fresh healthy meal delivery",
    "slug": "https://www.inspiredgo.ca/pages/static/fresh-healthy-meal-delivery"
  },
  {
    "name": "ready-to-eat healthy meals",
    "slug": "https://www.inspiredgo.ca/pages/static/ready-to-eat-healthy-meals"
  },
  {
    "name": "top-rated healthy meal delivery",
    "slug": "https://www.inspiredgo.ca/pages/static/top-rated-healthy-meal-delivery"
  },
  {
    "name": "healthy meal prep services",
    "slug": "https://www.inspiredgo.ca/pages/static/healthy-meal-prep-services"
  },
  {
    "name": "healthy meals for delivery",
    "slug": "https://www.inspiredgo.ca/pages/static/healthy-meals-for-delivery"
  },
  {
    "name": "meal delivery for healthy eating",
    "slug": "https://www.inspiredgo.ca/pages/static/meal-delivery-for-healthy-eating"
  },
  {
    "name": "healthy family meal delivery",
    "slug": "https://www.inspiredgo.ca/pages/static/healthy-family-meal-delivery"
  },
  {
    "name": "healthy meal delivery options",
    "slug": "https://www.inspiredgo.ca/pages/static/healthy-meal-delivery-options"
  },
  {
    "name": "personalized healthy meal delivery",
    "slug": "https://www.inspiredgo.ca/pages/static/personalized-healthy-meal-delivery"
  },
  {
    "name": "healthy meal prep kits",
    "slug": "https://www.inspiredgo.ca/pages/static/healthy-meal-prep-kits"
  },
  {
    "name": "healthy meal plans delivered",
    "slug": "https://www.inspiredgo.ca/pages/static/healthy-meal-plans-delivered"
  },
  {
    "name": "healthy meal delivery for weight loss",
    "slug": "https://www.inspiredgo.ca/pages/static/healthy-meal-delivery-for-weight-loss"
  },
  {
    "name": "quick healthy meal delivery",
    "slug": "https://www.inspiredgo.ca/pages/static/quick-healthy-meal-delivery"
  },
  {
    "name": "healthy meal prep delivery",
    "slug": "https://www.inspiredgo.ca/pages/static/healthy-meal-prep-delivery"
  },
  {
    "name": "healthy meal delivery for offices",
    "slug": "https://www.inspiredgo.ca/pages/static/healthy-meal-delivery-for-offices"
  },
  {
    "name": "fresh meal prep delivery",
    "slug": "https://www.inspiredgo.ca/pages/static/fresh-meal-prep-delivery"
  },
  {
    "name": "healthy meal delivery near me",
    "slug": "https://www.inspiredgo.ca/pages/static/healthy-meal-delivery-near-me"
  },
  {
    "name": "healthy dinner delivery service",
    "slug": "https://www.inspiredgo.ca/pages/static/healthy-dinner-delivery-service"
  },
  {
    "name": "healthy lunch delivery near me",
    "slug": "https://www.inspiredgo.ca/pages/static/healthy-lunch-delivery-near-me"
  },
  {
    "name": "healthy food meal delivery plans",
    "slug": "https://www.inspiredgo.ca/pages/static/healthy-food-meal-delivery-plans"
  },
  {
    "name": "convenient healthy meal delivery",
    "slug": "https://www.inspiredgo.ca/pages/static/convenient-healthy-meal-delivery"
  },
  {
    "name": "healthy meal delivery subscription",
    "slug": "https://www.inspiredgo.ca/pages/static/healthy-meal-delivery-subscription"
  },
  {
    "name": "nutritious meal delivery service",
    "slug": "https://www.inspiredgo.ca/pages/static/nutritious-meal-delivery-service"
  },
  {
    "name": "meal prep for healthy living",
    "slug": "https://www.inspiredgo.ca/pages/static/meal-prep-for-healthy-living"
  },
  {
    "name": "healthy meal prep delivery near me",
    "slug": "https://www.inspiredgo.ca/pages/static/healthy-meal-prep-delivery-near-me"
  },
  {
    "name": "healthy meal delivery for families",
    "slug": "https://www.inspiredgo.ca/pages/static/healthy-meal-delivery-for-families"
  },
  {
    "name": "meal delivery for health-conscious",
    "slug": "https://www.inspiredgo.ca/pages/static/meal-delivery-for-health-conscious"
  },
  {
    "name": "prepped healthy meals for delivery",
    "slug": "https://www.inspiredgo.ca/pages/static/prepped-healthy-meals-for-delivery"
  },
  {
    "name": "weekly meal prep delivery options",
    "slug": "https://www.inspiredgo.ca/pages/static/weekly-meal-prep-delivery-options"
  },
  {
    "name": "healthy meals delivered weekly",
    "slug": "https://www.inspiredgo.ca/pages/static/healthy-meals-delivered-weekly"
  },
  {
    "name": "best healthy meal plans",
    "slug": "https://www.inspiredgo.ca/pages/static/best-healthy-meal-plans"
  },
  {
    "name": "healthy meals for fitness",
    "slug": "https://www.inspiredgo.ca/pages/static/healthy-meals-for-fitness"
  },
  {
    "name": "convenient meal prep delivery",
    "slug": "https://www.inspiredgo.ca/pages/static/convenient-meal-prep-delivery"
  },
  {
    "name": "nutritious meal prep delivery service",
    "slug": "https://www.inspiredgo.ca/pages/static/nutritious-meal-prep-delivery-service"
  },
  {
    "name": "meal delivery for health goals",
    "slug": "https://www.inspiredgo.ca/pages/static/meal-delivery-for-health-goals"
  },
  {
    "name": "healthy prepared meals delivered",
    "slug": "https://www.inspiredgo.ca/pages/static/healthy-prepared-meals-delivered"
  },
  {
    "name": "home-delivered healthy meals",
    "slug": "https://www.inspiredgo.ca/pages/static/home-delivered-healthy-meals"
  },
  {
    "name": "meal prep for healthy eating",
    "slug": "https://www.inspiredgo.ca/pages/static/meal-prep-for-healthy-eating"
  },
  {
    "name": "healthy meal kits for delivery",
    "slug": "https://www.inspiredgo.ca/pages/static/healthy-meal-kits-for-delivery"
  },
  {
    "name": "healthy food delivery options",
    "slug": "https://www.inspiredgo.ca/pages/static/healthy-food-delivery-options"
  },
  {
    "name": "best meal delivery for health",
    "slug": "https://www.inspiredgo.ca/pages/static/best-meal-delivery-for-health"
  },
  {
    "name": "fresh healthy dinner delivery",
    "slug": "https://www.inspiredgo.ca/pages/static/fresh-healthy-dinner-delivery"
  },
  {
    "name": "healthy meal delivery and prep",
    "slug": "https://www.inspiredgo.ca/pages/static/healthy-meal-delivery-and-prep"
  },
  {
    "name": "quick healthy meal prep",
    "slug": "https://www.inspiredgo.ca/pages/static/quick-healthy-meal-prep"
  },
  {
    "name": "fresh meal kits delivered",
    "slug": "https://www.inspiredgo.ca/pages/static/fresh-meal-kits-delivered"
  },
  {
    "name": "healthy food prep delivery",
    "slug": "https://www.inspiredgo.ca/pages/static/healthy-food-prep-delivery"
  },
  {
    "name": "meal delivery for healthy diets",
    "slug": "https://www.inspiredgo.ca/pages/static/meal-delivery-for-healthy-diets"
  },
  {
    "name": "healthy prepped meals for delivery",
    "slug": "https://www.inspiredgo.ca/pages/static/healthy-prepped-meals-for-delivery"
  },
  {
    "name": "balanced meal delivery options",
    "slug": "https://www.inspiredgo.ca/pages/static/balanced-meal-delivery-options"
  },
  {
    "name": "meal kits for healthy living",
    "slug": "https://www.inspiredgo.ca/pages/static/meal-kits-for-healthy-living"
  },
  {
    "name": "meal prep delivery for fitness",
    "slug": "https://www.inspiredgo.ca/pages/static/meal-prep-delivery-for-fitness"
  },
  {
    "name": "healthy weekly meal delivery",
    "slug": "https://www.inspiredgo.ca/pages/static/healthy-weekly-meal-delivery"
  },
  {
    "name": "meal prep delivery for diets",
    "slug": "https://www.inspiredgo.ca/pages/static/meal-prep-delivery-for-diets"
  },
  {
    "name": "fresh meal prep for health",
    "slug": "https://www.inspiredgo.ca/pages/static/fresh-meal-prep-for-health"
  },
  {
    "name": "healthy meal prep delivery service",
    "slug": "https://www.inspiredgo.ca/pages/static/healthy-meal-prep-delivery-service"
  },
  {
    "name": "nutritious meal kits for delivery",
    "slug": "https://www.inspiredgo.ca/pages/static/nutritious-meal-kits-for-delivery"
  },
  {
    "name": "healthy meal delivery for individuals",
    "slug": "https://www.inspiredgo.ca/pages/static/healthy-meal-delivery-for-individuals"
  },
  {
    "name": "healthy food delivery near me",
    "slug": "https://www.inspiredgo.ca/pages/static/healthy-food-delivery-near-me"
  },
  {
    "name": "best healthy dinner delivery",
    "slug": "https://www.inspiredgo.ca/pages/static/best-healthy-dinner-delivery"
  },
  {
    "name": "healthy ready-to-eat meal delivery",
    "slug": "https://www.inspiredgo.ca/pages/static/healthy-ready-to-eat-meal-delivery"
  },
  {
    "name": "weekly healthy meal delivery service",
    "slug": "https://www.inspiredgo.ca/pages/static/weekly-healthy-meal-delivery-service"
  },
  {
    "name": "convenient healthy dinner delivery",
    "slug": "https://www.inspiredgo.ca/pages/static/convenient-healthy-dinner-delivery"
  },
  {
    "name": "pre-made healthy meal delivery",
    "slug": "https://www.inspiredgo.ca/pages/static/pre-made-healthy-meal-delivery"
  },
  {
    "name": "meal prep and delivery service",
    "slug": "https://www.inspiredgo.ca/pages/static/meal-prep-and-delivery-service"
  },
  {
    "name": "best healthy delivery",
    "slug": "https://www.inspiredgo.ca/pages/static/best-healthy-delivery"
  },
  {
    "name": "fresh healthy meals for delivery",
    "slug": "https://www.inspiredgo.ca/pages/static/fresh-healthy-meals-for-delivery"
  },
  {
    "name": "customizable healthy meal delivery",
    "slug": "https://www.inspiredgo.ca/pages/static/customizable-healthy-meal-delivery"
  },
  {
    "name": "easy healthy meal delivery options",
    "slug": "https://www.inspiredgo.ca/pages/static/easy-healthy-meal-delivery-options"
  },
  {
    "name": "nutritious meal delivery plans",
    "slug": "https://www.inspiredgo.ca/pages/static/nutritious-meal-delivery-plans"
  },
  {
    "name": "healthy meal prep delivery online",
    "slug": "https://www.inspiredgo.ca/pages/static/healthy-meal-prep-delivery-online"
  },
  {
    "name": "healthy eating meal kits",
    "slug": "https://www.inspiredgo.ca/pages/static/healthy-eating-meal-kits"
  },
  {
    "name": "best meal prep for health",
    "slug": "https://www.inspiredgo.ca/pages/static/best-meal-prep-for-health"
  },
  {
    "name": "healthy dinner meal delivery",
    "slug": "https://www.inspiredgo.ca/pages/static/healthy-dinner-meal-delivery"
  },
  {
    "name": "healthy lunch meal delivery",
    "slug": "https://www.inspiredgo.ca/pages/static/healthy-lunch-meal-delivery"
  },
  {
    "name": "meal delivery for healthy meals",
    "slug": "https://www.inspiredgo.ca/pages/static/meal-delivery-for-healthy-meals"
  },
  {
    "name": "best prepared healthy meals",
    "slug": "https://www.inspiredgo.ca/pages/static/best-prepared-healthy-meals"
  },
  {
    "name": "healthy food prep services",
    "slug": "https://www.inspiredgo.ca/pages/static/healthy-food-prep-services"
  },
  {
    "name": "meal prep services near me",
    "slug": "https://www.inspiredgo.ca/pages/static/meal-prep-services-near-me"
  },
  {
    "name": "fresh food delivery for health",
    "slug": "https://www.inspiredgo.ca/pages/static/fresh-food-delivery-for-health"
  },
  {
    "name": "prepped healthy food delivery",
    "slug": "https://www.inspiredgo.ca/pages/static/prepped-healthy-food-delivery"
  },
  {
    "name": "diet-friendly meal delivery options",
    "slug": "https://www.inspiredgo.ca/pages/static/diet-friendly-meal-delivery-options"
  },
  {
    "name": "fresh healthy food prep delivery",
    "slug": "https://www.inspiredgo.ca/pages/static/fresh-healthy-food-prep-delivery"
  },
  {
    "name": "meal prep delivery for health-conscious",
    "slug": "https://www.inspiredgo.ca/pages/static/meal-prep-delivery-for-health-conscious"
  },
  {
    "name": "prepped meals for healthy diets",
    "slug": "https://www.inspiredgo.ca/pages/static/prepped-meals-for-healthy-diets"
  },
  {
    "name": "best healthy prepared meal delivery",
    "slug": "https://www.inspiredgo.ca/pages/static/best-healthy-prepared-meal-delivery"
  },
  {
    "name": "healthy meal delivery without subscription",
    "slug": "https://www.inspiredgo.ca/pages/static/healthy-meal-delivery-without-subscription"
  },
  {
    "name": "fresh meal prep for families",
    "slug": "https://www.inspiredgo.ca/pages/static/fresh-meal-prep-for-families"
  },
  {
    "name": "quick-prep healthy meal delivery",
    "slug": "https://www.inspiredgo.ca/pages/static/quick-prep-healthy-meal-delivery"
  },
  {
    "name": "meal prep delivery options",
    "slug": "https://www.inspiredgo.ca/pages/static/meal-prep-delivery-options"
  },
  {
    "name": "best healthy meal prep plans",
    "slug": "https://www.inspiredgo.ca/pages/static/best-healthy-meal-prep-plans"
  },
  {
    "name": "family-friendly healthy meal delivery",
    "slug": "https://www.inspiredgo.ca/pages/static/family-friendly-healthy-meal-delivery"
  },
  {
    "name": "nutritious meal prep delivery kits",
    "slug": "https://www.inspiredgo.ca/pages/static/nutritious-meal-prep-delivery-kits"
  },
  {
    "name": "best meal prep for busy lifestyles",
    "slug": "https://www.inspiredgo.ca/pages/static/best-meal-prep-for-busy-lifestyles"
  },
  {
    "name": "weekly delivery of healthy meals",
    "slug": "https://www.inspiredgo.ca/pages/static/weekly-delivery-of-healthy-meals"
  },
  {
    "name": "pre-made healthy dinner delivery",
    "slug": "https://www.inspiredgo.ca/pages/static/pre-made-healthy-dinner-delivery"
  },
  {
    "name": "meal prep delivery",
    "slug": "https://www.inspiredgo.ca/pages/static/meal-prep-delivery"
  },
  {
    "name": "best meal prep",
    "slug": "https://www.inspiredgo.ca/pages/static/best-meal-prep"
  },
  {
    "name": "weekly meal prep",
    "slug": "https://www.inspiredgo.ca/pages/static/weekly-meal-prep"
  },
  {
    "name": "meal prep service",
    "slug": "https://www.inspiredgo.ca/pages/static/meal-prep-service"
  },
  {
    "name": "top rated meal prep",
    "slug": "https://www.inspiredgo.ca/pages/static/top-rated-meal-prep"
  },
  {
    "name": "local meal prep",
    "slug": "https://www.inspiredgo.ca/pages/static/local-meal-prep"
  },
  {
    "name": "fresh meal prep",
    "slug": "https://www.inspiredgo.ca/pages/static/fresh-meal-prep"
  },
  {
    "name": "custom meal prep",
    "slug": "https://www.inspiredgo.ca/pages/static/custom-meal-prep"
  },
  {
    "name": "meal prep plans",
    "slug": "https://www.inspiredgo.ca/pages/static/meal-prep-plans"
  },
  {
    "name": "pre-made meal prep",
    "slug": "https://www.inspiredgo.ca/pages/static/pre-made-meal-prep"
  },
  {
    "name": "meal prep kits",
    "slug": "https://www.inspiredgo.ca/pages/static/meal-prep-kits"
  },
  {
    "name": "meal prep boxes",
    "slug": "https://www.inspiredgo.ca/pages/static/meal-prep-boxes"
  },
  {
    "name": "ready meal delivery",
    "slug": "https://www.inspiredgo.ca/pages/static/ready-meal-delivery"
  },
  {
    "name": "quick meal prep",
    "slug": "https://www.inspiredgo.ca/pages/static/quick-meal-prep"
  },
  {
    "name": "family meal prep",
    "slug": "https://www.inspiredgo.ca/pages/static/family-meal-prep"
  },
  {
    "name": "home meal prep",
    "slug": "https://www.inspiredgo.ca/pages/static/home-meal-prep"
  },
  {
    "name": "best meal delivery",
    "slug": "https://www.inspiredgo.ca/pages/static/best-meal-delivery"
  },
  {
    "name": "meal prep subscription",
    "slug": "https://www.inspiredgo.ca/pages/static/meal-prep-subscription"
  },
  {
    "name": "fresh meal kits",
    "slug": "https://www.inspiredgo.ca/pages/static/fresh-meal-kits"
  },
  {
    "name": "premium meal delivery",
    "slug": "https://www.inspiredgo.ca/pages/static/premium-meal-delivery"
  },
  {
    "name": "meal delivery service",
    "slug": "https://www.inspiredgo.ca/pages/static/meal-delivery-service"
  },
  {
    "name": "weekly meal delivery",
    "slug": "https://www.inspiredgo.ca/pages/static/weekly-meal-delivery"
  },
  {
    "name": "top-rated meal prep",
    "slug": "https://www.inspiredgo.ca/pages/static/top-rated-meal-prep"
  },
  {
    "name": "meal delivery plans",
    "slug": "https://www.inspiredgo.ca/pages/static/meal-delivery-plans"
  },
  {
    "name": "home-delivered meals",
    "slug": "https://www.inspiredgo.ca/pages/static/home-delivered-meals"
  },
  {
    "name": "ready-made meal kits",
    "slug": "https://www.inspiredgo.ca/pages/static/ready-made-meal-kits"
  },
  {
    "name": "customized meal prep",
    "slug": "https://www.inspiredgo.ca/pages/static/customized-meal-prep"
  },
  {
    "name": "meal prep solutions",
    "slug": "https://www.inspiredgo.ca/pages/static/meal-prep-solutions"
  },
  {
    "name": "convenient meal prep",
    "slug": "https://www.inspiredgo.ca/pages/static/convenient-meal-prep"
  },
  {
    "name": "quick meal delivery",
    "slug": "https://www.inspiredgo.ca/pages/static/quick-meal-delivery"
  },
  {
    "name": "best meal prep delivery",
    "slug": "https://www.inspiredgo.ca/pages/static/best-meal-prep-delivery"
  },
  {
    "name": "weekly meal prep plans",
    "slug": "https://www.inspiredgo.ca/pages/static/weekly-meal-prep-plans"
  },
  {
    "name": "top rated meal prep service",
    "slug": "https://www.inspiredgo.ca/pages/static/top-rated-meal-prep-service"
  },
  {
    "name": "meal prep delivery service",
    "slug": "https://www.inspiredgo.ca/pages/static/meal-prep-delivery-service"
  },
  {
    "name": "local meal prep delivery",
    "slug": "https://www.inspiredgo.ca/pages/static/local-meal-prep-delivery"
  },
  {
    "name": "family meal prep plans",
    "slug": "https://www.inspiredgo.ca/pages/static/family-meal-prep-plans"
  },
  {
    "name": "pre-made meal prep kits",
    "slug": "https://www.inspiredgo.ca/pages/static/pre-made-meal-prep-kits"
  },
  {
    "name": "customized meal prep service",
    "slug": "https://www.inspiredgo.ca/pages/static/customized-meal-prep-service"
  },
  {
    "name": "best weekly meal prep",
    "slug": "https://www.inspiredgo.ca/pages/static/best-weekly-meal-prep"
  },
  {
    "name": "ready-to-eat meal delivery",
    "slug": "https://www.inspiredgo.ca/pages/static/ready-to-eat-meal-delivery"
  },
  {
    "name": "home-cooked meal prep service",
    "slug": "https://www.inspiredgo.ca/pages/static/home-cooked-meal-prep-service"
  },
  {
    "name": "fresh weekly meal delivery",
    "slug": "https://www.inspiredgo.ca/pages/static/fresh-weekly-meal-delivery"
  },
  {
    "name": "meal prep plans delivered",
    "slug": "https://www.inspiredgo.ca/pages/static/meal-prep-plans-delivered"
  },
  {
    "name": "ready-made meal prep service",
    "slug": "https://www.inspiredgo.ca/pages/static/ready-made-meal-prep-service"
  },
  {
    "name": "best meal prep plans",
    "slug": "https://www.inspiredgo.ca/pages/static/best-meal-prep-plans"
  },
  {
    "name": "top-rated meal prep services",
    "slug": "https://www.inspiredgo.ca/pages/static/top-rated-meal-prep-services"
  },
  {
    "name": "meal delivery for offices",
    "slug": "https://www.inspiredgo.ca/pages/static/meal-delivery-for-offices"
  },
  {
    "name": "pre-prepared meal delivery service",
    "slug": "https://www.inspiredgo.ca/pages/static/pre-prepared-meal-delivery-service"
  },
  {
    "name": "meal prep service online",
    "slug": "https://www.inspiredgo.ca/pages/static/meal-prep-service-online"
  },
  {
    "name": "weekly meal delivery service",
    "slug": "https://www.inspiredgo.ca/pages/static/weekly-meal-delivery-service"
  },
  {
    "name": "best meal prep options",
    "slug": "https://www.inspiredgo.ca/pages/static/best-meal-prep-options"
  },
  {
    "name": "best meal prep kits",
    "slug": "https://www.inspiredgo.ca/pages/static/best-meal-prep-kits"
  },
  {
    "name": "meal delivery without subscription",
    "slug": "https://www.inspiredgo.ca/pages/static/meal-delivery-without-subscription"
  },
  {
    "name": "ready-to-serve meal delivery",
    "slug": "https://www.inspiredgo.ca/pages/static/ready-to-serve-meal-delivery"
  },
  {
    "name": "fresh prepped meal boxes",
    "slug": "https://www.inspiredgo.ca/pages/static/fresh-prepped-meal-boxes"
  },
  {
    "name": "convenient meal prep plans",
    "slug": "https://www.inspiredgo.ca/pages/static/convenient-meal-prep-plans"
  },
  {
    "name": "meal prep service near me",
    "slug": "https://www.inspiredgo.ca/pages/static/meal-prep-service-near-me"
  },
  {
    "name": "quick weekly meal delivery",
    "slug": "https://www.inspiredgo.ca/pages/static/quick-weekly-meal-delivery"
  },
  {
    "name": "best meal delivery subscription",
    "slug": "https://www.inspiredgo.ca/pages/static/best-meal-delivery-subscription"
  },
  {
    "name": "meal prep subscription service",
    "slug": "https://www.inspiredgo.ca/pages/static/meal-prep-subscription-service"
  },
  {
    "name": "weekly prepped meal delivery",
    "slug": "https://www.inspiredgo.ca/pages/static/weekly-prepped-meal-delivery"
  },
  {
    "name": "pre-made family meals delivered",
    "slug": "https://www.inspiredgo.ca/pages/static/pre-made-family-meals-delivered"
  },
  {
    "name": "best weekly meal delivery",
    "slug": "https://www.inspiredgo.ca/pages/static/best-weekly-meal-delivery"
  },
  {
    "name": "fresh prepared meal kits",
    "slug": "https://www.inspiredgo.ca/pages/static/fresh-prepared-meal-kits"
  },
  {
    "name": "meal delivery subscription plans",
    "slug": "https://www.inspiredgo.ca/pages/static/meal-delivery-subscription-plans"
  },
  {
    "name": "best meal prep options",
    "slug": "https://www.inspiredgo.ca/pages/static/best-meal-prep-options"
  },
  {
    "name": "best ready-made meal delivery",
    "slug": "https://www.inspiredgo.ca/pages/static/best-ready-made-meal-delivery"
  },
  {
    "name": "customized weekly meal plans",
    "slug": "https://www.inspiredgo.ca/pages/static/customized-weekly-meal-plans"
  },
  {
    "name": "quick-prep meal delivery service",
    "slug": "https://www.inspiredgo.ca/pages/static/quick-prep-meal-delivery-service"
  },
  {
    "name": "family-friendly meal prep service",
    "slug": "https://www.inspiredgo.ca/pages/static/family-friendly-meal-prep-service"
  },
  {
    "name": "home-delivered weekly meal plans",
    "slug": "https://www.inspiredgo.ca/pages/static/home-delivered-weekly-meal-plans"
  },
  {
    "name": "meal delivery for professionals",
    "slug": "https://www.inspiredgo.ca/pages/static/meal-delivery-for-professionals"
  },
  {
    "name": "ready-made meal delivery options",
    "slug": "https://www.inspiredgo.ca/pages/static/ready-made-meal-delivery-options"
  },
  {
    "name": "prepped weekly meal kits",
    "slug": "https://www.inspiredgo.ca/pages/static/prepped-weekly-meal-kits"
  },
  {
    "name": "convenient weekly meal service",
    "slug": "https://www.inspiredgo.ca/pages/static/convenient-weekly-meal-service"
  },
  {
    "name": "meal prep packages delivered",
    "slug": "https://www.inspiredgo.ca/pages/static/meal-prep-packages-delivered"
  },
  {
    "name": "weekly meal service plans",
    "slug": "https://www.inspiredgo.ca/pages/static/weekly-meal-service-plans"
  },
  {
    "name": "best pre-made meal service",
    "slug": "https://www.inspiredgo.ca/pages/static/best-pre-made-meal-service"
  },
  {
    "name": "best family meal prep delivery",
    "slug": "https://www.inspiredgo.ca/pages/static/best-family-meal-prep-delivery"
  },
  {
    "name": "meal prep boxes delivered",
    "slug": "https://www.inspiredgo.ca/pages/static/meal-prep-boxes-delivered"
  },
  {
    "name": "best family meal prep service",
    "slug": "https://www.inspiredgo.ca/pages/static/best-family-meal-prep-service"
  },
  {
    "name": "meal prep solutions for families",
    "slug": "https://www.inspiredgo.ca/pages/static/meal-prep-solutions-for-families"
  },
  {
    "name": "quick meal prep delivery service",
    "slug": "https://www.inspiredgo.ca/pages/static/quick-meal-prep-delivery-service"
  },
  {
    "name": "pre-cooked meal prep kits",
    "slug": "https://www.inspiredgo.ca/pages/static/pre-cooked-meal-prep-kits"
  },
  {
    "name": "weekly meal prep subscription service",
    "slug": "https://www.inspiredgo.ca/pages/static/weekly-meal-prep-subscription-service"
  },
  {
    "name": "best meal delivery options",
    "slug": "https://www.inspiredgo.ca/pages/static/best-meal-delivery-options"
  },
  {
    "name": "prepped meals delivered weekly",
    "slug": "https://www.inspiredgo.ca/pages/static/prepped-meals-delivered-weekly"
  },
  {
    "name": "meal delivery solutions for families",
    "slug": "https://www.inspiredgo.ca/pages/static/meal-delivery-solutions-for-families"
  },
  {
    "name": "home-delivered weekly meal kits",
    "slug": "https://www.inspiredgo.ca/pages/static/home-delivered-weekly-meal-kits"
  },
  {
    "name": "ready-made weekly meal plans",
    "slug": "https://www.inspiredgo.ca/pages/static/ready-made-weekly-meal-plans"
  },
  {
    "name": "meal delivery service without subscription",
    "slug": "https://www.inspiredgo.ca/pages/static/meal-delivery-service-without-subscription"
  },
  {
    "name": "meal prep plans for families",
    "slug": "https://www.inspiredgo.ca/pages/static/meal-prep-plans-for-families"
  },
  {
    "name": "top weekly meal delivery options",
    "slug": "https://www.inspiredgo.ca/pages/static/top-weekly-meal-delivery-options"
  },
  {
    "name": "best meal delivery without subscription",
    "slug": "https://www.inspiredgo.ca/pages/static/best-meal-delivery-without-subscription"
  },
  {
    "name": "best meal prep subscription",
    "slug": "https://www.inspiredgo.ca/pages/static/best-meal-prep-subscription"
  },
  {
    "name": "meal prep service for professionals",
    "slug": "https://www.inspiredgo.ca/pages/static/meal-prep-service-for-professionals"
  },
  {
    "name": "pre-packed meal delivery services",
    "slug": "https://www.inspiredgo.ca/pages/static/pre-packed-meal-delivery-services"
  },
  {
    "name": "quick meal delivery service plans",
    "slug": "https://www.inspiredgo.ca/pages/static/quick-meal-delivery-service-plans"
  },
  {
    "name": "family-friendly weekly meal delivery",
    "slug": "https://www.inspiredgo.ca/pages/static/family-friendly-weekly-meal-delivery"
  },
  {
    "name": "meal delivery subscriptions",
    "slug": "https://www.inspiredgo.ca/pages/static/meal-delivery-subscriptions"
  },
  {
    "name": "diet food delivery",
    "slug": "https://www.inspiredgo.ca/pages/static/diet-food-delivery"
  },
  {
    "name": "diet meal prep",
    "slug": "https://www.inspiredgo.ca/pages/static/diet-meal-prep"
  },
  {
    "name": "diet food service",
    "slug": "https://www.inspiredgo.ca/pages/static/diet-food-service"
  },
  {
    "name": "diet meal kits",
    "slug": "https://www.inspiredgo.ca/pages/static/diet-meal-kits"
  },
  {
    "name": "weekly diet meals",
    "slug": "https://www.inspiredgo.ca/pages/static/weekly-diet-meals"
  },
  {
    "name": "diet food plans",
    "slug": "https://www.inspiredgo.ca/pages/static/diet-food-plans"
  },
  {
    "name": "best diet delivery service",
    "slug": "https://www.inspiredgo.ca/pages/static/best-diet-delivery-service"
  },
  {
    "name": "diet meal services",
    "slug": "https://www.inspiredgo.ca/pages/static/diet-meal-services"
  },
  {
    "name": "diet-friendly meals",
    "slug": "https://www.inspiredgo.ca/pages/static/diet-friendly-meals"
  },
  {
    "name": "diet food boxes",
    "slug": "https://www.inspiredgo.ca/pages/static/diet-food-boxes"
  },
  {
    "name": "diet food subscription",
    "slug": "https://www.inspiredgo.ca/pages/static/diet-food-subscription"
  },
  {
    "name": "diet meal subscription",
    "slug": "https://www.inspiredgo.ca/pages/static/diet-meal-subscription"
  },
  {
    "name": "diet-focused meal prep",
    "slug": "https://www.inspiredgo.ca/pages/static/diet-focused-meal-prep"
  },
  {
    "name": "low-calorie diet meals",
    "slug": "https://www.inspiredgo.ca/pages/static/low-calorie-diet-meals"
  },
  {
    "name": "ready diet meals",
    "slug": "https://www.inspiredgo.ca/pages/static/ready-diet-meals"
  },
  {
    "name": "diet food packages",
    "slug": "https://www.inspiredgo.ca/pages/static/diet-food-packages"
  },
  {
    "name": "diet food prep",
    "slug": "https://www.inspiredgo.ca/pages/static/diet-food-prep"
  },
  {
    "name": "portion diet meals",
    "slug": "https://www.inspiredgo.ca/pages/static/portion-diet-meals"
  },
  {
    "name": "diet delivery service",
    "slug": "https://www.inspiredgo.ca/pages/static/diet-delivery-service"
  },
  {
    "name": "calorie diet meals",
    "slug": "https://www.inspiredgo.ca/pages/static/calorie-diet-meals"
  },
  {
    "name": "diet-friendly delivery",
    "slug": "https://www.inspiredgo.ca/pages/static/diet-friendly-delivery"
  },
  {
    "name": "diet-friendly kits",
    "slug": "https://www.inspiredgo.ca/pages/static/diet-friendly-kits"
  },
  {
    "name": "ready diet food",
    "slug": "https://www.inspiredgo.ca/pages/static/ready-diet-food"
  },
  {
    "name": "diet-focused meal kits",
    "slug": "https://www.inspiredgo.ca/pages/static/diet-focused-meal-kits"
  },
  {
    "name": "calorie meal plans",
    "slug": "https://www.inspiredgo.ca/pages/static/calorie-meal-plans"
  },
  {
    "name": "diet portion meals",
    "slug": "https://www.inspiredgo.ca/pages/static/diet-portion-meals"
  },
  {
    "name": "prepped diet meals",
    "slug": "https://www.inspiredgo.ca/pages/static/prepped-diet-meals"
  },
  {
    "name": "best diet delivery",
    "slug": "https://www.inspiredgo.ca/pages/static/best-diet-delivery"
  },
  {
    "name": "diet-focused delivery service",
    "slug": "https://www.inspiredgo.ca/pages/static/diet-focused-delivery-service"
  },
  {
    "name": "weekly diet delivery",
    "slug": "https://www.inspiredgo.ca/pages/static/weekly-diet-delivery"
  },
  {
    "name": "diet prep service",
    "slug": "https://www.inspiredgo.ca/pages/static/diet-prep-service"
  },
  {
    "name": "best diet meals online",
    "slug": "https://www.inspiredgo.ca/pages/static/best-diet-meals-online"
  },
  {
    "name": "portion diet delivery",
    "slug": "https://www.inspiredgo.ca/pages/static/portion-diet-delivery"
  },
  {
    "name": "diet delivery options",
    "slug": "https://www.inspiredgo.ca/pages/static/diet-delivery-options"
  },
  {
    "name": "meal prep diet",
    "slug": "https://www.inspiredgo.ca/pages/static/meal-prep-diet"
  },
  {
    "name": "best diet meal delivery",
    "slug": "https://www.inspiredgo.ca/pages/static/best-diet-meal-delivery"
  },
  {
    "name": "top rated diet meal prep",
    "slug": "https://www.inspiredgo.ca/pages/static/top-rated-diet-meal-prep"
  },
  {
    "name": "weekly diet meal kits",
    "slug": "https://www.inspiredgo.ca/pages/static/weekly-diet-meal-kits"
  },
  {
    "name": "diet-focused meal delivery",
    "slug": "https://www.inspiredgo.ca/pages/static/diet-focused-meal-delivery"
  },
  {
    "name": "ready-to-eat diet meals",
    "slug": "https://www.inspiredgo.ca/pages/static/ready-to-eat-diet-meals"
  },
  {
    "name": "portion-controlled diet meals",
    "slug": "https://www.inspiredgo.ca/pages/static/portion-controlled-diet-meals"
  },
  {
    "name": "diet meal delivery plans",
    "slug": "https://www.inspiredgo.ca/pages/static/diet-meal-delivery-plans"
  },
  {
    "name": "best diet food service",
    "slug": "https://www.inspiredgo.ca/pages/static/best-diet-food-service"
  },
  {
    "name": "best prepped diet meals",
    "slug": "https://www.inspiredgo.ca/pages/static/best-prepped-diet-meals"
  },
  {
    "name": "low-calorie diet food delivery",
    "slug": "https://www.inspiredgo.ca/pages/static/low-calorie-diet-food-delivery"
  },
  {
    "name": "diet-focused subscription plans",
    "slug": "https://www.inspiredgo.ca/pages/static/diet-focused-subscription-plans"
  },
  {
    "name": "ready-made diet meal delivery",
    "slug": "https://www.inspiredgo.ca/pages/static/ready-made-diet-meal-delivery"
  },
  {
    "name": "weekly diet food delivery",
    "slug": "https://www.inspiredgo.ca/pages/static/weekly-diet-food-delivery"
  },
  {
    "name": "pre-prepared diet food service",
    "slug": "https://www.inspiredgo.ca/pages/static/pre-prepared-diet-food-service"
  },
  {
    "name": "calorie-controlled diet meals",
    "slug": "https://www.inspiredgo.ca/pages/static/calorie-controlled-diet-meals"
  },
  {
    "name": "best ready diet meals",
    "slug": "https://www.inspiredgo.ca/pages/static/best-ready-diet-meals"
  },
  {
    "name": "diet meal prep solutions",
    "slug": "https://www.inspiredgo.ca/pages/static/diet-meal-prep-solutions"
  },
  {
    "name": "diet meal delivery service",
    "slug": "https://www.inspiredgo.ca/pages/static/diet-meal-delivery-service"
  },
  {
    "name": "best weekly diet meals",
    "slug": "https://www.inspiredgo.ca/pages/static/best-weekly-diet-meals"
  },
  {
    "name": "prepped diet meal kits",
    "slug": "https://www.inspiredgo.ca/pages/static/prepped-diet-meal-kits"
  },
  {
    "name": "diet-focused weekly delivery",
    "slug": "https://www.inspiredgo.ca/pages/static/diet-focused-weekly-delivery"
  },
  {
    "name": "diet-friendly subscription boxes",
    "slug": "https://www.inspiredgo.ca/pages/static/diet-friendly-subscription-boxes"
  },
  {
    "name": "low-sodium diet food delivery",
    "slug": "https://www.inspiredgo.ca/pages/static/low-sodium-diet-food-delivery"
  },
  {
    "name": "quick diet meal delivery",
    "slug": "https://www.inspiredgo.ca/pages/static/quick-diet-meal-delivery"
  },
  {
    "name": "ready-to-serve diet meals",
    "slug": "https://www.inspiredgo.ca/pages/static/ready-to-serve-diet-meals"
  },
  {
    "name": "best low calorie diet meals",
    "slug": "https://www.inspiredgo.ca/pages/static/best-low-calorie-diet-meals"
  },
  {
    "name": "weekly portion diet meals",
    "slug": "https://www.inspiredgo.ca/pages/static/weekly-portion-diet-meals"
  },
  {
    "name": "customized diet food delivery",
    "slug": "https://www.inspiredgo.ca/pages/static/customized-diet-food-delivery"
  },
  {
    "name": "pre-made weekly diet meals",
    "slug": "https://www.inspiredgo.ca/pages/static/pre-made-weekly-diet-meals"
  },
  {
    "name": "best weekly diet plans",
    "slug": "https://www.inspiredgo.ca/pages/static/best-weekly-diet-plans"
  },
  {
    "name": "calorie-focused diet meal delivery",
    "slug": "https://www.inspiredgo.ca/pages/static/calorie-focused-diet-meal-delivery"
  },
  {
    "name": "quick prepped diet meals",
    "slug": "https://www.inspiredgo.ca/pages/static/quick-prepped-diet-meals"
  },
  {
    "name": "low-fat diet meal service",
    "slug": "https://www.inspiredgo.ca/pages/static/low-fat-diet-meal-service"
  },
  {
    "name": "best calorie-focused diet plans",
    "slug": "https://www.inspiredgo.ca/pages/static/best-calorie-focused-diet-plans"
  },
  {
    "name": "pre-portioned diet food kits",
    "slug": "https://www.inspiredgo.ca/pages/static/pre-portioned-diet-food-kits"
  },
  {
    "name": "diet meal delivery",
    "slug": "https://www.inspiredgo.ca/pages/static/diet-meal-delivery"
  },
  {
    "name": "diet prep service",
    "slug": "https://www.inspiredgo.ca/pages/static/diet-prep-service"
  },
  {
    "name": "weekly diet delivery",
    "slug": "https://www.inspiredgo.ca/pages/static/weekly-diet-delivery"
  },
  {
    "name": "diet meal plans",
    "slug": "https://www.inspiredgo.ca/pages/static/diet-meal-plans"
  },
  {
    "name": "diet prep kits",
    "slug": "https://www.inspiredgo.ca/pages/static/diet-prep-kits"
  },
  {
    "name": "diet delivery service",
    "slug": "https://www.inspiredgo.ca/pages/static/diet-delivery-service"
  },
  {
    "name": "best diet delivery",
    "slug": "https://www.inspiredgo.ca/pages/static/best-diet-delivery"
  },
  {
    "name": "diet portion meals",
    "slug": "https://www.inspiredgo.ca/pages/static/diet-portion-meals"
  },
  {
    "name": "diet food boxes",
    "slug": "https://www.inspiredgo.ca/pages/static/diet-food-boxes"
  },
  {
    "name": "diet meal options",
    "slug": "https://www.inspiredgo.ca/pages/static/diet-meal-options"
  },
  {
    "name": "diet delivery plans",
    "slug": "https://www.inspiredgo.ca/pages/static/diet-delivery-plans"
  },
  {
    "name": "diet meal subscription",
    "slug": "https://www.inspiredgo.ca/pages/static/diet-meal-subscription"
  },
  {
    "name": "diet-focused meal kits",
    "slug": "https://www.inspiredgo.ca/pages/static/diet-focused-meal-kits"
  },
  {
    "name": "prepped diet meals",
    "slug": "https://www.inspiredgo.ca/pages/static/prepped-diet-meals"
  },
  {
    "name": "diet meal packages",
    "slug": "https://www.inspiredgo.ca/pages/static/diet-meal-packages"
  },
  {
    "name": "best diet meal delivery",
    "slug": "https://www.inspiredgo.ca/pages/static/best-diet-meal-delivery"
  },
  {
    "name": "best diet prep kits",
    "slug": "https://www.inspiredgo.ca/pages/static/best-diet-prep-kits"
  },
  {
    "name": "weekly diet prep plans",
    "slug": "https://www.inspiredgo.ca/pages/static/weekly-diet-prep-plans"
  },
  {
    "name": "portion-controlled diet meals",
    "slug": "https://www.inspiredgo.ca/pages/static/portion-controlled-diet-meals"
  },
  {
    "name": "customized diet meal delivery",
    "slug": "https://www.inspiredgo.ca/pages/static/customized-diet-meal-delivery"
  },
  {
    "name": "ready-made diet meal plans",
    "slug": "https://www.inspiredgo.ca/pages/static/ready-made-diet-meal-plans"
  },
  {
    "name": "best prepped diet meals",
    "slug": "https://www.inspiredgo.ca/pages/static/best-prepped-diet-meals"
  },
  {
    "name": "diet meal subscription plans",
    "slug": "https://www.inspiredgo.ca/pages/static/diet-meal-subscription-plans"
  },
  {
    "name": "best weekly diet meals",
    "slug": "https://www.inspiredgo.ca/pages/static/best-weekly-diet-meals"
  },
  {
    "name": "portion-focused diet meal kits",
    "slug": "https://www.inspiredgo.ca/pages/static/portion-focused-diet-meal-kits"
  },
  {
    "name": "diet meal plans delivered",
    "slug": "https://www.inspiredgo.ca/pages/static/diet-meal-plans-delivered"
  },
  {
    "name": "diet-friendly portion meal delivery",
    "slug": "https://www.inspiredgo.ca/pages/static/diet-friendly-portion-meal-delivery"
  },
  {
    "name": "calorie-focused diet meal service",
    "slug": "https://www.inspiredgo.ca/pages/static/calorie-focused-diet-meal-service"
  },
  {
    "name": "pre-packaged diet meal delivery",
    "slug": "https://www.inspiredgo.ca/pages/static/pre-packaged-diet-meal-delivery"
  },
  {
    "name": "weekly diet-focused meal prep",
    "slug": "https://www.inspiredgo.ca/pages/static/weekly-diet-focused-meal-prep"
  },
  {
    "name": "vegetarian meal plans",
    "slug": "https://www.inspiredgo.ca/pages/static/vegetarian-meal-plans"
  },
  {
    "name": "vegetarian food delivery",
    "slug": "https://www.inspiredgo.ca/pages/static/vegetarian-food-delivery"
  },
  {
    "name": "vegetarian dinner kits",
    "slug": "https://www.inspiredgo.ca/pages/static/vegetarian-dinner-kits"
  },
  {
    "name": "vegetarian lunch delivery",
    "slug": "https://www.inspiredgo.ca/pages/static/vegetarian-lunch-delivery"
  },
  {
    "name": "vegetarian family meals",
    "slug": "https://www.inspiredgo.ca/pages/static/vegetarian-family-meals"
  },
  {
    "name": "vegetarian weekly delivery",
    "slug": "https://www.inspiredgo.ca/pages/static/vegetarian-weekly-delivery"
  },
  {
    "name": "pre-made vegetarian meals",
    "slug": "https://www.inspiredgo.ca/pages/static/pre-made-vegetarian-meals"
  },
  {
    "name": "vegetarian prep kits",
    "slug": "https://www.inspiredgo.ca/pages/static/vegetarian-prep-kits"
  },
  {
    "name": "vegetarian meal subscriptions",
    "slug": "https://www.inspiredgo.ca/pages/static/vegetarian-meal-subscriptions"
  },
  {
    "name": "vegetarian meal packages",
    "slug": "https://www.inspiredgo.ca/pages/static/vegetarian-meal-packages"
  },
  {
    "name": "vegetarian dinner delivery",
    "slug": "https://www.inspiredgo.ca/pages/static/vegetarian-dinner-delivery"
  },
  {
    "name": "weekly vegetarian prep",
    "slug": "https://www.inspiredgo.ca/pages/static/weekly-vegetarian-prep"
  },
  {
    "name": "vegetarian meal boxes",
    "slug": "https://www.inspiredgo.ca/pages/static/vegetarian-meal-boxes"
  },
  {
    "name": "prepped vegetarian meals",
    "slug": "https://www.inspiredgo.ca/pages/static/prepped-vegetarian-meals"
  },
  {
    "name": "custom vegetarian meals",
    "slug": "https://www.inspiredgo.ca/pages/static/custom-vegetarian-meals"
  },
  {
    "name": "vegetarian food kits",
    "slug": "https://www.inspiredgo.ca/pages/static/vegetarian-food-kits"
  },
  {
    "name": "vegetarian portion meals",
    "slug": "https://www.inspiredgo.ca/pages/static/vegetarian-portion-meals"
  },
  {
    "name": "vegetarian meal orders",
    "slug": "https://www.inspiredgo.ca/pages/static/vegetarian-meal-orders"
  },
  {
    "name": "ready vegetarian meals",
    "slug": "https://www.inspiredgo.ca/pages/static/ready-vegetarian-meals"
  },
  {
    "name": "vegetarian lunch kits",
    "slug": "https://www.inspiredgo.ca/pages/static/vegetarian-lunch-kits"
  },
  {
    "name": "best vegetarian meal service",
    "slug": "https://www.inspiredgo.ca/pages/static/best-vegetarian-meal-service"
  },
  {
    "name": "vegetarian weekly meal delivery",
    "slug": "https://www.inspiredgo.ca/pages/static/vegetarian-weekly-meal-delivery"
  },
  {
    "name": "custom vegetarian meal plans",
    "slug": "https://www.inspiredgo.ca/pages/static/custom-vegetarian-meal-plans"
  },
  {
    "name": "ready-made vegetarian meal kits",
    "slug": "https://www.inspiredgo.ca/pages/static/ready-made-vegetarian-meal-kits"
  },
  {
    "name": "prepped vegetarian meal kits",
    "slug": "https://www.inspiredgo.ca/pages/static/prepped-vegetarian-meal-kits"
  },
  {
    "name": "vegetarian subscription meal service",
    "slug": "https://www.inspiredgo.ca/pages/static/vegetarian-subscription-meal-service"
  },
  {
    "name": "vegetarian dinner prep delivery",
    "slug": "https://www.inspiredgo.ca/pages/static/vegetarian-dinner-prep-delivery"
  },
  {
    "name": "weekly vegetarian meal service",
    "slug": "https://www.inspiredgo.ca/pages/static/weekly-vegetarian-meal-service"
  },
  {
    "name": "vegetarian family meal plans",
    "slug": "https://www.inspiredgo.ca/pages/static/vegetarian-family-meal-plans"
  },
  {
    "name": "vegetarian meal delivery options",
    "slug": "https://www.inspiredgo.ca/pages/static/vegetarian-meal-delivery-options"
  },
  {
    "name": "vegetarian meals for offices",
    "slug": "https://www.inspiredgo.ca/pages/static/vegetarian-meals-for-offices"
  },
  {
    "name": "vegetarian dinner prep kits",
    "slug": "https://www.inspiredgo.ca/pages/static/vegetarian-dinner-prep-kits"
  },
  {
    "name": "vegetarian weekly prep kits",
    "slug": "https://www.inspiredgo.ca/pages/static/vegetarian-weekly-prep-kits"
  },
  {
    "name": "vegetarian portion meal delivery",
    "slug": "https://www.inspiredgo.ca/pages/static/vegetarian-portion-meal-delivery"
  },
  {
    "name": "pre-prepared vegetarian food service",
    "slug": "https://www.inspiredgo.ca/pages/static/pre-prepared-vegetarian-food-service"
  },
  {
    "name": "vegetarian meal kits subscription",
    "slug": "https://www.inspiredgo.ca/pages/static/vegetarian-meal-kits-subscription"
  },
  {
    "name": "vegetarian lunch prep delivery",
    "slug": "https://www.inspiredgo.ca/pages/static/vegetarian-lunch-prep-delivery"
  },
  {
    "name": "ready-prepped vegetarian meals",
    "slug": "https://www.inspiredgo.ca/pages/static/ready-prepped-vegetarian-meals"
  },
  {
    "name": "pre-cooked vegetarian food kits",
    "slug": "https://www.inspiredgo.ca/pages/static/pre-cooked-vegetarian-food-kits"
  },
  {
    "name": "weekly vegetarian dinner plans",
    "slug": "https://www.inspiredgo.ca/pages/static/weekly-vegetarian-dinner-plans"
  },
  {
    "name": "vegetarian food for delivery",
    "slug": "https://www.inspiredgo.ca/pages/static/vegetarian-food-for-delivery"
  },
  {
    "name": "vegetarian meal delivery plans",
    "slug": "https://www.inspiredgo.ca/pages/static/vegetarian-meal-delivery-plans"
  },
  {
    "name": "vegetarian dinner kits delivered",
    "slug": "https://www.inspiredgo.ca/pages/static/vegetarian-dinner-kits-delivered"
  },
  {
    "name": "custom vegetarian prep delivery",
    "slug": "https://www.inspiredgo.ca/pages/static/custom-vegetarian-prep-delivery"
  },
  {
    "name": "vegetarian dinner food prep",
    "slug": "https://www.inspiredgo.ca/pages/static/vegetarian-dinner-food-prep"
  },
  {
    "name": "vegetarian meals for families",
    "slug": "https://www.inspiredgo.ca/pages/static/vegetarian-meals-for-families"
  },
  {
    "name": "vegetarian meal delivery subscription",
    "slug": "https://www.inspiredgo.ca/pages/static/vegetarian-meal-delivery-subscription"
  },
  {
    "name": "ready vegetarian meal options",
    "slug": "https://www.inspiredgo.ca/pages/static/ready-vegetarian-meal-options"
  },
  {
    "name": "weekly vegetarian meal service plans",
    "slug": "https://www.inspiredgo.ca/pages/static/weekly-vegetarian-meal-service-plans"
  },
  {
    "name": "vegetarian food subscription kits",
    "slug": "https://www.inspiredgo.ca/pages/static/vegetarian-food-subscription-kits"
  },
  {
    "name": "vegetarian meal service",
    "slug": "https://www.inspiredgo.ca/pages/static/vegetarian-meal-service"
  },
  {
    "name": "pre-cooked vegetarian meals",
    "slug": "https://www.inspiredgo.ca/pages/static/pre-cooked-vegetarian-meals"
  },
  {
    "name": "vegetarian food options",
    "slug": "https://www.inspiredgo.ca/pages/static/vegetarian-food-options"
  },
  {
    "name": "vegetarian meal prep kits",
    "slug": "https://www.inspiredgo.ca/pages/static/vegetarian-meal-prep-kits"
  },
  {
    "name": "vegetarian weekly meals",
    "slug": "https://www.inspiredgo.ca/pages/static/vegetarian-weekly-meals"
  },
  {
    "name": "pre-prepped vegetarian kits",
    "slug": "https://www.inspiredgo.ca/pages/static/pre-prepped-vegetarian-kits"
  },
  {
    "name": "vegetarian dinner plans",
    "slug": "https://www.inspiredgo.ca/pages/static/vegetarian-dinner-plans"
  },
  {
    "name": "vegetarian meal subscriptions online",
    "slug": "https://www.inspiredgo.ca/pages/static/vegetarian-meal-subscriptions-online"
  },
  {
    "name": "vegetarian meal box delivery",
    "slug": "https://www.inspiredgo.ca/pages/static/vegetarian-meal-box-delivery"
  },
  {
    "name": "vegetarian lunch prep",
    "slug": "https://www.inspiredgo.ca/pages/static/vegetarian-lunch-prep"
  },
  {
    "name": "ready vegetarian kits",
    "slug": "https://www.inspiredgo.ca/pages/static/ready-vegetarian-kits"
  },
  {
    "name": "vegetarian meal catering",
    "slug": "https://www.inspiredgo.ca/pages/static/vegetarian-meal-catering"
  },
  {
    "name": "vegetarian weekly food kits",
    "slug": "https://www.inspiredgo.ca/pages/static/vegetarian-weekly-food-kits"
  },
  {
    "name": "custom vegetarian plans",
    "slug": "https://www.inspiredgo.ca/pages/static/custom-vegetarian-plans"
  },
  {
    "name": "pre-made vegetarian kits",
    "slug": "https://www.inspiredgo.ca/pages/static/pre-made-vegetarian-kits"
  },
  {
    "name": "best vegetarian prep service",
    "slug": "https://www.inspiredgo.ca/pages/static/best-vegetarian-prep-service"
  },
  {
    "name": "vegetarian meal plan delivery",
    "slug": "https://www.inspiredgo.ca/pages/static/vegetarian-meal-plan-delivery"
  },
  {
    "name": "ready-prepped vegetarian dinner kits",
    "slug": "https://www.inspiredgo.ca/pages/static/ready-prepped-vegetarian-dinner-kits"
  },
  {
    "name": "weekly vegetarian subscription service",
    "slug": "https://www.inspiredgo.ca/pages/static/weekly-vegetarian-subscription-service"
  },
  {
    "name": "custom vegetarian meal packages",
    "slug": "https://www.inspiredgo.ca/pages/static/custom-vegetarian-meal-packages"
  },
  {
    "name": "pre-cooked vegetarian meal kits",
    "slug": "https://www.inspiredgo.ca/pages/static/pre-cooked-vegetarian-meal-kits"
  },
  {
    "name": "vegetarian portion control meals",
    "slug": "https://www.inspiredgo.ca/pages/static/vegetarian-portion-control-meals"
  },
  {
    "name": "vegetarian food prep plans",
    "slug": "https://www.inspiredgo.ca/pages/static/vegetarian-food-prep-plans"
  },
  {
    "name": "ready-to-go vegetarian meals",
    "slug": "https://www.inspiredgo.ca/pages/static/ready-to-go-vegetarian-meals"
  },
  {
    "name": "vegetarian meal box kits",
    "slug": "https://www.inspiredgo.ca/pages/static/vegetarian-meal-box-kits"
  },
  {
    "name": "vegetarian food catering services",
    "slug": "https://www.inspiredgo.ca/pages/static/vegetarian-food-catering-services"
  },
  {
    "name": "best vegetarian subscription meals",
    "slug": "https://www.inspiredgo.ca/pages/static/best-vegetarian-subscription-meals"
  },
  {
    "name": "ready vegetarian family meals",
    "slug": "https://www.inspiredgo.ca/pages/static/ready-vegetarian-family-meals"
  },
  {
    "name": "vegetarian weekly dinner plans",
    "slug": "https://www.inspiredgo.ca/pages/static/vegetarian-weekly-dinner-plans"
  },
  {
    "name": "pre-made vegetarian food options",
    "slug": "https://www.inspiredgo.ca/pages/static/pre-made-vegetarian-food-options"
  },
  {
    "name": "vegetarian weekly delivery",
    "slug": "https://www.inspiredgo.ca/pages/static/vegetarian-weekly-delivery"
  },
  {
    "name": "vegetarian dinner options",
    "slug": "https://www.inspiredgo.ca/pages/static/vegetarian-dinner-options"
  },
  {
    "name": "pre-made vegetarian dinners",
    "slug": "https://www.inspiredgo.ca/pages/static/pre-made-vegetarian-dinners"
  },
  {
    "name": "vegetarian family meals",
    "slug": "https://www.inspiredgo.ca/pages/static/vegetarian-family-meals"
  },
  {
    "name": "vegetarian catering services",
    "slug": "https://www.inspiredgo.ca/pages/static/vegetarian-catering-services"
  },
  {
    "name": "vegetarian meal kits online",
    "slug": "https://www.inspiredgo.ca/pages/static/vegetarian-meal-kits-online"
  },
  {
    "name": "vegetarian weekly meal plans",
    "slug": "https://www.inspiredgo.ca/pages/static/vegetarian-weekly-meal-plans"
  },
  {
    "name": "ready vegetarian dinner",
    "slug": "https://www.inspiredgo.ca/pages/static/ready-vegetarian-dinner"
  },
  {
    "name": "custom vegetarian deliveries",
    "slug": "https://www.inspiredgo.ca/pages/static/custom-vegetarian-deliveries"
  },
  {
    "name": "vegetarian meal orders online",
    "slug": "https://www.inspiredgo.ca/pages/static/vegetarian-meal-orders-online"
  },
  {
    "name": "weekly vegetarian dinner delivery",
    "slug": "https://www.inspiredgo.ca/pages/static/weekly-vegetarian-dinner-delivery"
  },
  {
    "name": "vegetarian meal box subscription",
    "slug": "https://www.inspiredgo.ca/pages/static/vegetarian-meal-box-subscription"
  },
  {
    "name": "pre-prepared vegetarian food kits",
    "slug": "https://www.inspiredgo.ca/pages/static/pre-prepared-vegetarian-food-kits"
  },
  {
    "name": "vegetarian weekly prep plans",
    "slug": "https://www.inspiredgo.ca/pages/static/vegetarian-weekly-prep-plans"
  },
  {
    "name": "custom vegetarian food packages",
    "slug": "https://www.inspiredgo.ca/pages/static/custom-vegetarian-food-packages"
  },
  {
    "name": "ready-made vegetarian dinner options",
    "slug": "https://www.inspiredgo.ca/pages/static/ready-made-vegetarian-dinner-options"
  },
  {
    "name": "vegetarian food delivery service plans",
    "slug": "https://www.inspiredgo.ca/pages/static/vegetarian-food-delivery-service-plans"
  },
  {
    "name": "fresh vegetarian meal box delivery",
    "slug": "https://www.inspiredgo.ca/pages/static/fresh-vegetarian-meal-box-delivery"
  },
  {
    "name": "pre-prepped vegetarian dinner kits",
    "slug": "https://www.inspiredgo.ca/pages/static/pre-prepped-vegetarian-dinner-kits"
  },
  {
    "name": "weekly vegetarian food delivery service",
    "slug": "https://www.inspiredgo.ca/pages/static/weekly-vegetarian-food-delivery-service"
  }
];
/**
 * Obtains a random word from the word array.
 * @returns {Object} An object with the name and slug of a random word.
 */
function getRandomWord() {
  const randomIndex = Math.floor(Math.random() * words.length);
  return words[randomIndex];
}

/**
 * Gets the slug of a random word.
 * @returns {String} The slug of a random word.
 */
function getRandomWordSlug() {
  const randomWord = getRandomWord();
  return randomWord.slug;
}

/**
 * Gets the name of a random word.
 * @returns {String} The name of a random word.
 */
function getRandomWordName() {
  const randomWord = getRandomWord();
  return randomWord.name;
}
// Make features globally accessible
window.getRandomWord = getRandomWord;
window.getRandomWordSlug = getRandomWordSlug;
window.getRandomWordName = getRandomWordName;